import { LabelType, Options } from '@angular-slider/ngx-slider';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterContentInit, Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataProvider } from '@mysrc/app/Providers/DataProvider';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { CommonService } from '@mysrc/app/features/question/services/commonservice';
import { AgGridAngular } from 'ag-grid-angular';
import { AnyGridOptions } from 'ag-grid-community/dist/types/core/propertyKeys';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { SurveyEntity } from '../../../../models/surveyEntity';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import { SurveyService } from '../../services/survey/survey.service';


@Component({
  selector: 'app-page-survey-preview',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AgGridAngular,
    TabsModule,
    PopoverModule,
    BsDatepickerModule
  ],
  templateUrl: './page-survey-preview.component.html',
  styleUrl: './page-survey-preview.component.scss',
  providers: [CommonService, SurveyService, EncrDecrService, DataProvider]
})
export class PageSurveyPreviewComponent implements OnInit, AfterContentInit {
  private gridApi: any[] = [];
  queryParameters!: string[];
  successOrFailureMessage: string = '';
  boolquestions: boolean = false;
  selectedSection: any = { Name: '', Id: '' };
  surveyForm!: FormGroup;
  docForm!: FormGroup;
  sectionDocs!: FormGroup;
  sectionForm!: FormGroup;
  usersurveysettings!: FormGroup;
  userSingleLink!: FormGroup;
  sectionDocuments: SurveyEntity.uploadedDocuments[] = [];
  surveyData!: SurveyEntity.Meta;
  qSections!: SurveyEntity.Section[];
  iSections!: SurveyEntity.Section[];
  dSections: SurveyEntity.Section[] = [];
  currentSection: SurveyEntity.Section[] = [];
  public selectedFile!: File;
  public selectedFiles!: FileList;
  public tempdDcumentname!: string;
  isFileInvalid!: boolean;
  saveClicked: boolean = false;
  formArray = new FormArray([]);
  orderArray: number[] = [1, 2];
  surveyId!: string;
  serviceLineId!: string;
  companyId!: string;
  userId!: string;
  ssUserId!: string;
  currentDeletingdocumentId: number = -1;
  formchanged: boolean = false;
  myAppUrl: any;
  companyLogo: any;
  workspaceLogo: any;
  private gridapi: AnyGridOptions;
  private sectiongridapi: any;
  public formdata: FormData = new FormData();
  isDocInvalid!: boolean;
  isAllSectionConfirmed: boolean = true;
  DocSuccessOrFailureMessage: string = '';
  AdaptiveSettings!: SurveyEntity.AdaptiveAssessmentSettings[];
  DependentOptionList!: SurveyEntity.DependentQuestionOptionSettings[];
  OptionAndSectionList!: SurveyEntity.OptionAndSectionSettings[];
  public MergeCodeSettings: SurveyEntity.MergeCodeSettings[] = [];
  public questionLanguageSettingsList: QuestionLanguageSetting[] = [];
  public surveyProviderBucketSettingsList: surveyProviderBucketSetting[] = [];
  public surveyUserSectionSettingsList: surveyUserSectionSetting[] = [];
  public MatrixQuestionConditionalSettings: MatrixQuestionConditionalSetting[] = [];
  public mcDependentOptionSetting!: SurveyEntity.DependentQuestionOptionSettings[];
  public latestMergeTextUI: string = "";
  showQuestionNumber: boolean = false;
  showQuestionPrefix: boolean = false;
  filledDependentOption: boolean = false;
  tmpEditResponse: boolean = false;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache'
    })
  }
  isPreview: any;
  isJustSubmitted: boolean = false;
  public isJustExited: boolean = false;
  public isJustExitedQuestionId: number = -1;
  public JustExitedsectionId: number = -1;
  public _getAssessmentDataUrl: string = 'ManageServiceLine/GetAssessmentDetails';
  //public _UpdateSurveyResponseDataOnEditUrl: string = 'Survey/UpdateSurveyResponseDataOnEditUrl';
  public _SurveySaveResponseUrl: string = 'Survey/SaveSurveyResponse';
  public _updateSurveyStatusUrl: string = 'Survey/updateSurveyStatus';
  public _UpdateForcefullySubmittedStatusUrl: string = 'Survey/UpdateForcefullySubmittedStatus';
  public _SurveySubmitSurveyUrl: string = 'Survey/SubmitSurvey';
  public _downLoadUrl: string = 'Survey/DownloadDocument';
  public _uploadUrl: string = 'Survey/DocumentUpload';
  public _removeUrl: string = 'Survey/RemoveDocument';
  public _fetchsectiondocs: string = "Survey/GetSectionDocuments";
  //public _fetchCompanyLogo: string = "Survey/GetCompanyLogo";
  //public _getMergeCodeSettings: string = "Survey/GetMergeCodeSettings";
  public _getSurveyQuestionResponseByUser: string = "Survey/GetSurveyQuestionResponseByUser";
  public _getSingleSurveyLinkUserDetailsUrl: string = "Survey/GetSurveyUserByEmail";
  public _getAllSurveyProviderBucketSettingsUrl: string = 'Survey/GetAllSurveyProviderBucketSettings';
  public _saveSurveyUserSectionSettingsUrl: string = 'Survey/SaveSurveyUserSectionDetails';
  public _getSurveyUserSectionSettingsUrl: string = 'Survey/GetSurveyUserSectionMappedDetails'
  public _getUIAttributesByCopiedSurveyIdUrl: string = 'Survey/GetUIAttributesByCopiedSurveyId'
  //public _getprogressbarattributes: string = 'Survey/GetUIAttributesByIdentifierID/';
  public _saveSingleSurveyDetailsUrl: string = 'Survey/SaveSingleSurveyLinkDetails';
  //public _getSurveyMessagesUrl: string = 'Survey/GetSurveyMessagesAndLanguage';

  public _languageList: SurveyEntity.Language[] = [];
  public surveyProviderLanguageMappedDetails: SurveyProviderLanguageMappedDetails[] = [];
  public singleSurveyLinkUserDetails!: SingleSurveyLinkUserDetails;
  public surveyMessagesList: SurveyEntity.SurveyMessageAndLanguage[] = [];
  public preferredLanguageId: number = 0;
  public userFirstName!: string;
  public userLastName!: string;
  public userEmailAddress!: string;
  public preferredLanguageSet: boolean = false;
  surveySubmitTriggered!: boolean;
  surveyTriggered!: boolean;
  public requiredValidationTriggered: boolean = false;
  public _updateConfirmation: string = 'Survey/updateUserConfirmation';
  formDirty!: boolean;
  preloader: boolean = true;
  activeTabId: number = 1;
  isQuestionnaire: boolean = false;
  totalQuestionCount: number = 0;
  attemptedQuestionCount: number = 0;
  attemptedPercentage: number = 0;
  tabIndex: number = 0;
  isQuestionnaireTabActive: boolean = false;
  lastTab: boolean = false;
  firstTab: boolean = false;
  SurveyAfterSubmitMessage!: string;
  AllReadySubmittedSurveyMessage!: string;
  ExpiredSurveyMessage!: string;
  ForcefullyExited!: string;
  AlreadyForcefullyExited!: string;
  ForcefullyExitedBackToSurvey!: string;
  SubmitPopupMessage!: string;
  sliderForm!: FormGroup;
  currentSlidingDetails!: SurveyEntity.GradingRangeDetails[];
  minRange!: number;
  maxRange!: number;
  minDesc!: string;
  maxDesc!: string;
  options!: Options;
  optionList: OptionList[] = [];
  objOptions!: OptionList;
  surveyLanguageCode: string = '';
  key_Next: string = "Next";
  key_Prev: string = "Prev";
  key_Home: string = "Home";
  key_Submit: string = "Submit";
  key_home_Message_Part1: string = "Are you sure you want to exit ?";
  key_home_Message_Part2: string = "If you have done any changes, please save them before exit. Any unsaved changes will be lost.";
  key_Note: string = "NOTE";
  key_Yes: string = "Yes";
  key_No: string = "No";
  key_Exit_Survey_Confirmation: string = "Exit Survey Confirmation";
  key_Survey_SubmitPopupMessage!: string;
  languageCode: string = "en";
  preferredLanguageCode: string = "en";
  key_Survey_SurveyAfterSubmitMessage!: string
  key_Survey_AllReadySubmittedSurveyMessage!: string
  key_Survey_ExpiredSurveyMessage!: string
  key_Survey_Submit_Label: string = "Submit Survey Confirmation"
  key_Close: string = "Close"
  key_Wait_Message!: string
  key_Wait_OF!: string
  key_Wait_Answered!: string
  key_Previous_Tab_Save_Message: string = "Previous tab has been saved."
  key_Previous_Tab_Save_Title: string = "Autosalva"
  key_Next_Validation_Message: string = "Please answer all mandatory questions correctly highlighted in red."
  key_Survey_SaveForLater: string = "Save For Later";
  pickListItemList: SurveyEntity.PickListItem[] = [];
  pickListItem!: SurveyEntity.PickListItem;
  //public _getSurveyProgressBarConfigUrl: string = 'Survey/GetSurveyProgressBarConfigurations';

  //public _getSectionConfigUrl: string = 'Survey/GetSectionConfigration/';
  public sectionConfigDetails!: sectionConfigDetail[];

  //public _fetchWorkspaceIdUrl: string = "Survey/GetWorkspaceID/";

  public surveyProgressbarConfigDetails!: mappedSurveyProgressbarConfigDetail[];
  public showProgressBarUp: boolean = false;
  public showProgressBarDown: boolean = false;

  public workspaceId: number = 0;

  private uiSetting!: UISetting[];

  public showDocumentUploads: boolean = true;

  constructor(
    private http: HttpClient,
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private _router: Router,
    @Inject('BASE_URL') baseUrl: string,
    private commonService: CommonService,
    private surveyService: SurveyService,
    //private toasterService: ToastrService,
    private dataProvider: DataProvider,
    private EncrDecr: EncrDecrService,
    @Inject('CONFIG_SETTINGS') configSettings: any
    //private translate: TranslateService
  ) {

    const genSettings = configSettings[<any>'general'];
    baseUrl = genSettings[<any>'adminApiUrl'];
    this.myAppUrl = baseUrl + '/';


    ////this.toasterService.toastrConfig.progressBar = true;
    //console.log(JSON.stringify(this.dataProvider.data));
  }
  ngAfterContentInit() {
    if (this.preloader == true) {
      window.setTimeout(() => {
        this.preloader = false;
        const loaders = document.querySelectorAll('.loader1');
        loaders.forEach(el => this.renderer.removeClass(el, 'is-active'));
        const chosenEls = document.querySelectorAll('.chosenClass');
        chosenEls.forEach((el: any) => {
          if (typeof (window as any).jQuery !== 'undefined' && typeof (el).chosen === 'function') {
            (window as any).jQuery(el).chosen({ width: '200px' });
          }
          el.addEventListener('change', function (this: HTMLElement, evt: Event) {
            this.click();
          });
        });
      }, 3000);
    }

  }
  ngAfterContentChecked() {
    if (this.surveyData !== undefined && this.surveyData.surveytype === 'SectionPerPageWithPlainLayout') {
      $('.nav.nav-tabs').css('display', 'none');
      $('#userProfile').css('display', 'none');
      $('.nav-item.dropdown').css('display', 'none');
      $('#workspaceLogo').css('display', 'none');
      $('#surveyName').css('display', 'block');
      $('#LisurveyName').css('display', 'block');

      $('#surveyName').html(this.surveyData.surveytitle);
      if (this.companyLogo != null && this.companyLogo != '') {
        $('#companyLogo').attr("src", this.companyLogo);
      }
      $('#workspaceLogo').attr("src", this.workspaceLogo);
      $('#companyLogo').css('display', 'block');
      $('#licompanyLogo').css('display', 'block');

    }

    if (this.workspaceId == 1) {
      // only for IPL
      this.applySectionColor();
    }
    if (this.filledDependentOption) {
      window.setTimeout(() => {
        $('.chosenClass').trigger("chosen:updated");
        this.filledDependentOption = false;
      }, 10);
    }

  }
  applySectionColor() {
    if (this.sectionConfigDetails != undefined && this.sectionConfigDetails.length > 0) {
      for (var i = 0; i < this.sectionConfigDetails.length; i++) {
        var sectionColor = this.sectionConfigDetails[i].sectionBGColor;
        var sectionId = this.sectionConfigDetails[i].sectionId;
        if ($(`#${sectionId}-link`)[0] != undefined) {
          $(`#${sectionId}-link`)[0].style.backgroundColor = sectionColor;
          $(`#${sectionId}-link`)[0].style.borderColor = sectionColor;
        }
      }
    }
  }

  ngAfterViewChecked() {
    if (this.workspaceId == 2) {
      //only for assessment
      this.ApplyUIConfiguration();
    }

    $("select").change(function () {
      if ($(this).val() == "") $(this).css({ color: "#aaa" });
      else $(this).css({ color: "#000" });
    });
  }
  ngOnInit() {
    this.fetchWorkspaceId();
    this.usersurveysettings = this.formBuilder.group({
      userFirstName: new FormControl("", Validators.required),
      userLastName: new FormControl('', Validators.required),
      userEmailAddress: new FormControl('', Validators.required)
    });

    this.userSingleLink = this.formBuilder.group({
      userEmailAddress: new FormControl('', Validators.required)
    });

    if (this.dataProvider.data == null || this.dataProvider.data == "undefined") {
      if (localStorage.getItem('fromModule') == "Survey") {
        //  this._router.navigate(['../survey']);
        let queryString = this.route.snapshot.queryParams["q"] || '';
        if (queryString != '') {
          let decryptedQueryString = this.EncrDecr.get(queryString);
          if (decryptedQueryString != '') {
            this.queryParameters = decryptedQueryString.split(',');
            this.serviceLineId = this.queryParameters[0] || '-1';
            this.surveyId = this.queryParameters[1] || '-1';
            this.companyId = this.queryParameters[2] || '-1';
            this.isPreview = false;
            this.loadSurvey();

          }
        }
        else {
          //this._router.navigate(['../provider']);
        }
      }
      else if (localStorage.getItem('fromModule') == "Report") {
        //this._router.navigate(['../report']);
      }
      else {
        let queryString = this.route.snapshot.queryParams["q"] || '';
        if (queryString != '') {
          let decryptedQueryString = this.EncrDecr.get(queryString);
          if (decryptedQueryString != '') {
            this.queryParameters = decryptedQueryString.split(',');
            this.serviceLineId = this.queryParameters[0] || '-1';
            this.surveyId = this.queryParameters[1] || '-1';
            this.companyId = this.queryParameters[2] || '-1';
            this.ssUserId = this.queryParameters[3] || '-1';

            if (this.ssUserId === '-1') {
              var surveyIdString = 'surveyId_' + this.surveyId;
              var localStorageString = localStorage.getItem(surveyIdString);

              if (localStorageString !== '' && localStorageString !== null) {
                this.ssUserId = localStorageString;
                var qString = this.EncrDecr.set(this.serviceLineId + ',' + this.surveyId + ',' + this.companyId + ',' + localStorageString);
                window.location.href = this.myAppUrl + "survey-preview" + "?q=" + qString;
              }
            }
            //if (this.ssUserId === '-2') {
            //  var surveyIdString = 'surveyId_' + this.surveyId;
            //  var localStorageString = localStorage.getItem(surveyIdString);

            //  if (localStorageString !== '' && localStorageString !== null) {
            //    this.ssUserId = localStorageString;
            //    var qString = this.EncrDecr.set(this.serviceLineId + ',' + this.surveyId + ',' + this.companyId + ',' + localStorageString);
            //    window.location.href = this.myAppUrl + "survey-preview" + "?q=" + qString;
            //  }
            //}

            this.isPreview = false;

            this.getSurveyProgressBarConfigs();

            this.showHideDocumentUploads();

            this.getIsEditResponsesValue();

            this.loadSurvey();

          }
        }
        else {
          //this._router.navigate(['../provider']);
        }
      }

    }
    else {
      this.surveyId = this.dataProvider.data.surveyId || '-1';
      this.serviceLineId = this.dataProvider.data.serviceLineId || '-1';
      this.companyId = this.dataProvider.data.companyId || '-1';
      this.isPreview = Boolean(this.dataProvider.data.isPreview) || false;

      var uId = this.EncrDecr.get(localStorage.getItem('userId') ?? "");
      this.ssUserId = uId;

      this.getSurveyProgressBarConfigs();

      this.loadSurvey();
      $(document).find('.bReq').removeClass('bReq');
    }
  }
  showHideDocumentUploads() {
    var url = window.location.href;
    if (url.includes("?q")) {
      this.showDocumentUploads = false;
    }
  }
  //Edit Responses
  getIsEditResponsesValue() {
    this.surveyService.updateSurveyResponse(this.surveyId, this.serviceLineId, this.companyId)
      .subscribe(result => {
        if (result.length > 0) {
          this.tmpEditResponse = result.isEditResponses;
        }
      }, error => alert(error));

  }
  getSurveyProgressBarConfigs() {
    this.surveyService.getProgressBarConfiguration(this.surveyId)
      .subscribe(result => {
        this.surveyProgressbarConfigDetails = result;
        var topSettings = (result as mappedSurveyProgressbarConfigDetail[]).filter(wh => wh.propertyValue === 'Top');
        var bottomSettings = (result as mappedSurveyProgressbarConfigDetail[]).filter(wh => wh.propertyValue === 'Down');
        if (topSettings.length > 0) {
          this.showProgressBarUp = true;
        }
        if (bottomSettings.length > 0) {
          this.showProgressBarDown = true;
        }
        if (topSettings.length <= 0 && bottomSettings.length <= 0) {
          this.showProgressBarDown = true;
        }
      });
  }
  getAllSectionConfiguration(surveyId: any) {
    this.surveyService.getAllSectionConfiguration(surveyId)
      .subscribe(result => {
        this.sectionConfigDetails = result;
      });

  }

  getUIConfiguration(surveyId: any) {
    this.surveyService.getUIConfiguration(surveyId)
      .subscribe(result => {
        if (result != null && result != undefined && result.length > 0) {
          this.uiSetting = result;
        }
      }, error => alert(error));
  }

  ApplyUIConfiguration() {
    if (this.uiSetting != undefined && this.uiSetting.length > 0) {

      //apply Prograssbar Setting
      var progressbarAttributes = this.uiSetting.find(x => x.uiControlName == 'progressbar')
      if (progressbarAttributes != undefined && progressbarAttributes != null) {
        var progressbarcolor = progressbarAttributes.styles.color
        if (document.getElementsByClassName('progress-bar')[0] != undefined) {
          var progressBarCount = document.getElementsByClassName('progress-bar').length
          for (var i = 0; i < progressBarCount; i++) {
            if (document.getElementsByClassName('progress-bar')[i] != undefined) {
              const progressBarElements = document.getElementsByClassName('progress-bar');
              for (let i = 0; i < progressBarElements.length; i++) {
                const el = progressBarElements[i] as HTMLElement;
                if (el && el.style) {
                  el.style.backgroundColor = progressbarcolor;
                }
              }
            }
          }
        }
      }

      // apply separator Colors
      var separatorAttributes = this.uiSetting.find(x => x.uiControlName == 'separator');

      if (separatorAttributes != undefined && separatorAttributes != null) {
        var separatorcolor = separatorAttributes.styles.color;

        // Survey name border
        if (document.getElementsByClassName('survey-name-border')[0] != undefined) {
          var separatorCount = document.getElementsByClassName('survey-name-border').length;
          for (var i = 0; i < separatorCount; i++) {
            if (document.getElementsByClassName('survey-name-border')[i] != undefined) {
              const elements = document.getElementsByClassName('survey-name-border');
              for (let i = 0; i < elements.length; i++) {
                const el = elements[i] as HTMLElement;
                if (el && el.style) {
                  el.style.backgroundColor = separatorcolor;
                }
              }
            }
          }
        }

        // Section name
        if (document.getElementsByClassName('section-name')[0] != undefined) {
          var separatorCount = document.getElementsByClassName('section-name').length;
          for (var i = 0; i < separatorCount; i++) {
            if (document.getElementsByClassName('section-name')[i] != undefined) {
              const sectionNameElements = document.getElementsByClassName('section-name');
              for (let i = 0; i < sectionNameElements.length; i++) {
                const el = sectionNameElements[i] as HTMLElement;
                if (el && el.style) {
                  el.style.backgroundColor = separatorcolor;
                }
              }
            }
          }
        }

        // Card footer
        if (document.getElementsByClassName('card-footer')[0] != undefined) {
          (document.getElementsByClassName('card-footer')[0] as HTMLElement).style.borderColor = separatorcolor;
        }
      }

      // apply servey margin

      var serveyMarginrAttributes = this.uiSetting.find(x => x.uiControlName == 'SurveySecContMargin')
      if (serveyMarginrAttributes != undefined && serveyMarginrAttributes != null) {
        var serveyMargin = serveyMarginrAttributes.styles.margin
        if (document.getElementsByClassName('survey-container')[0] != undefined) {
          var progressBarCount = document.getElementsByClassName('survey-container').length
          for (var i = 0; i < progressBarCount; i++) {
            if (document.getElementsByClassName('survey-container')[i] != undefined) {
              const surveyContainers = document.getElementsByClassName('survey-container');
              for (let i = 0; i < surveyContainers.length; i++) {
                const el = surveyContainers[i] as HTMLElement;
                if (el && el.style) {
                  el.style.padding = serveyMargin;
                }
              }
            }
          }
        }
      }

      //apply button color configuration
      var buttonAttributes = this.uiSetting.find(x => x.uiControlName == 'ButtonBackgroundColor')
      if (buttonAttributes != undefined && buttonAttributes != null) {
        var buttonColValue = buttonAttributes.styles.color
        if (document.getElementsByClassName('btn-background-color')[0] != undefined) {
          var progressBarCount = document.getElementsByClassName('btn-background-color').length;
          for (var i = 0; i < progressBarCount; i++) {
            if (document.getElementsByClassName('btn-background-color')[i] != undefined) {
              const btnElements = document.getElementsByClassName('btn-background-color');
              for (let i = 0; i < btnElements.length; i++) {
                const el = btnElements[i] as HTMLElement;
                if (el && el.style) {
                  el.style.backgroundColor = buttonColValue;
                }
              }
            }
          }
        }
      }


      const sectionNameElements = document.getElementsByClassName('section-name');
      for (let i = 0; i < sectionNameElements.length; i++) {
        const el = sectionNameElements[i] as HTMLElement;
        if (el && el.style) {

          if (separatorAttributes != undefined && separatorAttributes != null) {
            var separatorcolor = separatorAttributes.styles.color;
            el.style.backgroundColor = separatorcolor;
          }
        }
      }
      // Footer color
      if (document.getElementsByClassName('card-footer')[0] != undefined && separatorAttributes != null) {
        var separatorcolor = separatorAttributes.styles.color;
        (document.getElementsByClassName('card-footer')[0] as HTMLElement).style.borderColor = separatorcolor;
      }
    }
  }

  fetchWorkspaceId() {
    this.surveyService.getWorkspaceId().subscribe(
      result => {
        this.workspaceId = result;
      }, error => { alert(error.message) });
  }

  findTotal(categoryValue: any, questionId: any, sectionId: any, form: any, params: any) {

    let tmpUniqueKey = sectionId + "_" + questionId;
    let tmpArray = [];
    $(params.target).removeClass('bRed');
    var arr = $('[name="subCategoryQuantity_' + tmpUniqueKey + '"]'); //document.getElementsByName('qty');
    var tot: number = 0.0;
    for (let i = 0; i < arr.length; i++) {
      arr[i].style.border = "";
      if ('value' in arr[i]) {
        const value = (arr[i] as HTMLInputElement).value;
        tmpArray.push(value);
        if (parseFloat(value)) {
          tot += parseFloat(value);
        }
      }
    }

    if (tot != categoryValue) {
      form.value.sections.forEach((qp: any, i: any) => {
        if (qp.id == sectionId) {
          qp.questions.forEach((qs: any, qsi: any) => {
            if (qs.qid == questionId) {
              this.requiredValidationTriggered = true;
              qs.isAnswered = false;
            }
          });
        }
      });
      ////this.toasterService.clear();
      ////this.toasterService.error("Sum of sub-category values should be equal to category value");
      return false;
    }
    if (tot == categoryValue) {
      form.value.sections.forEach((qp: any, i: any) => {
        if (qp.id == sectionId) {
          qp.questions.forEach((qs: any, qsi: any) => {
            if (qs.qid == questionId) {
              qs.isAnswered = true;
              this.requiredValidationTriggered = false;
            }

          });

        }

      });
      return true;
    }
    return false;
  }


  onSingleSurveyLinkNext() {
    this.userFirstName = this.usersurveysettings.value.userFirstName;
    this.userLastName = this.usersurveysettings.value.userLastName;
    this.userEmailAddress = this.usersurveysettings.value.userEmailAddress;
    var emailAddress = this.userEmailAddress;

    this.http.get<SingleSurveyLinkUserDetails>(this.myAppUrl + this._getSingleSurveyLinkUserDetailsUrl, {
      params: {
        'userEmail': emailAddress,
        'companyId': this.companyId
      }
    }).subscribe(data => {
      this.singleSurveyLinkUserDetails = data;

      //Create a new Link
      var qString = this.EncrDecr.set(this.serviceLineId + ',' + this.surveyId + ',' + this.companyId + ',' + this.singleSurveyLinkUserDetails.userId);
      var newSurveyLink = this.myAppUrl + "survey-preview" + "?q=" + qString;
      window.location.href = newSurveyLink;
    });
  }

  onSingleLinkNext() {
    this.userEmailAddress = this.userSingleLink.value.userEmailAddress;
    var emailAddress = this.userEmailAddress;

    this.http.get<SingleSurveyLinkUserDetails>(this.myAppUrl + this._getSingleSurveyLinkUserDetailsUrl, {
      params: {
        'userEmail': emailAddress,
        'companyId': this.companyId
      }
    }).subscribe(data => {
      this.singleSurveyLinkUserDetails = data;

      //Create a new Link
      var qString = this.EncrDecr.set(this.serviceLineId + ',' + this.surveyId + ',' + this.companyId + ',' + this.singleSurveyLinkUserDetails.userId);
      var newSurveyLink = this.myAppUrl + "survey-preview" + "?q=" + qString;

      if (this.singleSurveyLinkUserDetails.userId > 0) {

        const httpOptionsNew = {
          headers: new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
          }),
          params: {
            userEmailAddress: this.userEmailAddress,
            surveyLink: newSurveyLink,
            companyId: this.companyId,
            serviceLineId: this.serviceLineId,
            surveyId: this.surveyId,
            parentRecipient: "false"

          }
        };
        this.http.post(this.myAppUrl + this._saveSingleSurveyDetailsUrl, '', httpOptionsNew).subscribe(result => {
          if (result != null) {
          }
        }, error => { alert(error.message) });
      }

      if (this.singleSurveyLinkUserDetails.userId > 0) {
        window.location.href = newSurveyLink;
      }
      else {
        this.successOrFailureMessage = "Please enter a valid email.";
        window.setTimeout(() => {
          this.successOrFailureMessage = '';
        }, 6200);
      }
    });
  }
  // FrameworkUI/src/app/features/survey/pages/page-survey-preview/page-survey-preview.component.ts

  buildSurveyPayload(): any {
    const formValue = this.surveyForm.value;

    // Helper to ensure nested objects are always present
    const ensureObject = (obj: any, defaultObj: any) => (obj && typeof obj === 'object' ? obj : defaultObj);

    // Map sections and questions to required structure
    const sections = (formValue.sections || []).map((section: any) => ({
      id: section.id ?? 0,
      order: section.order ?? 0,
      name: section.name ?? '',
      description: section.description ?? '',
      type: section.type ?? '',
      questions: (section.questions || []).map((question: any) => ({
        qid: question.qid ?? 0,
        qrid: question.qrid ?? 0,
        text: question.text ?? '',
        value: question.value ?? '',
        order: question.order ?? 0,
        type: question.type ?? '',
        matrix: ensureObject(question.matrix, {
          rowdataFields: [],
          columnFields: [],
          columns: [],
          hideRowHeader: false,
          isEveryRowMandatory: false,
          headerDescription: '',
          headerValue: '',
          description: ''
        }),
        constantSum: ensureObject(question.constantSum, {
          rowdataFields: [],
          columnFields: [],
          columns: [],
          hideRowHeader: false,
          isEveryRowMandatory: false,
          categoryName: '',
          categoryDescription: '',
          categoryValue: 0
        }),
        multipleResponse: question.multipleResponse ?? [],
        multipleChoice: question.multipleChoice ?? [],
        rankingSort: question.rankingSort ?? [],
        description: ensureObject(question.description, { value: '' }),
        pickList: question.pickList ?? [],
        slider: question.slider ?? [],
        textInput: ensureObject(question.textInput, { value: '' }),
        isRequired: question.isRequired ?? false,
        isAnswered: question.isAnswered ?? false,
        defaultValue: question.defaultValue ?? '',
        displayNumberText: question.displayNumberText ?? '',
        isPartialAnswer: question.isPartialAnswer ?? false,
        width: question.width ?? '',
        maxCharacterLength: question.maxCharacterLength ?? '',
        questionPrefix: question.questionPrefix ?? '',
        isEmail: question.isEmail ?? false,
        isPhone: question.isPhone ?? false
      })),
      isConfirmationRequires: section.isConfirmationRequires ?? false,
      isConfirmed: section.isConfirmed ?? false,
      acceptedText: section.acceptedText ?? '',
      notAcceptedText: section.notAcceptedText ?? '',
      qSOrder: section.qSOrder ?? 0,
      isShowSection: section.isShowSection ?? false,
      isHide: section.isHide ?? false
    }));

    // Build the final payload
    return {
      surveyId: Number(formValue.surveyId ?? 0),
      responseId: Number(formValue.responseId ?? 0),
      serviceLineId: Number(formValue.serviceLineId ?? 0),
      companyId: Number(formValue.companyId ?? 0),
      userId: Number(formValue.userId ?? 0),
      surveytitle: formValue.surveytitle ?? '',
      surveydescription: formValue.surveydescription ?? '',
      surveytype: formValue.surveytype ?? '',
      isautosave: !!formValue.isautosave,
      isprogressbar: !!formValue.isprogressbar,
      perpage: Number(formValue.perpage ?? 0),
      isPreview: !!formValue.isPreview,
      isSubmitted: !!formValue.isSubmitted,
      isOverDue: !!formValue.isOverDue,
      isforcefullysubmitted: !!formValue.isforcefullysubmitted,
      surveyName: formValue.surveyName ?? '',
      showQuestionNumber: !!formValue.showQuestionNumber,
      showQuestionPrefix: !!formValue.showQuestionPrefix,
      isEditResponses: !!formValue.isEditResponses,
      sections
    };
  }
  onSaveForLater(form: any) {
    var tabs = this.surveyData.metaBody.sections;
    let currentSection: SurveyEntity.Section[];



    currentSection = form.value.sections
      .filter((wh: SurveyEntity.Section) => wh.type == 'Questionnaire' && wh.id == this.activeTabId)
      .sort((a: SurveyEntity.Section, b: SurveyEntity.Section) => a.qSOrder - b.qSOrder);

    this.currentSection = currentSection;
    var sectionId = currentSection[0].id;

    const surveyData = this.buildSurveyPayload();
    this.http.post(this.myAppUrl + this._SurveySaveResponseUrl, JSON.stringify(surveyData), this.httpOptions)
      .subscribe(result => {
        this.surveyForm.controls.flagChanges.markAsUntouched();
      });

    //this.http.post(this.myAppUrl + this._SurveySaveResponseUrl, JSON.stringify({ meta: data }), this.httpOptions)
    //  .subscribe(result => {
    //    this.surveyForm.controls.flagChanges.markAsUntouched();
    //  });
    //this.http.post(this.myAppUrl + this._SurveySaveResponseUrl, JSON.stringify({ meta: data }), this.httpOptions).subscribe(result => {
    ////this.http.post(this.myAppUrl + this._SurveySaveResponseUrl, JSON.stringify(data), this.httpOptions).subscribe(result => {
    //  this.surveyForm.controls.flagChanges.markAsUntouched();
    //  ////this.toasterService.clear();
    //  //   ////this.toasterService.success(this.key_Previous_Tab_Save_Message);
    //});

    //let parameters = "surveyId=" + this.surveyId + "&serviceLineId=" + this.serviceLineId + "&companyId=" + this.companyId + "&userId=" + this.userId + "&sectionId=" + sectionId.toString();
    //const httpOptions = {
    //  headers: new HttpHeaders({
    //    'Content-Type': 'application/x-www-form-urlencoded',
    //  })
    //}
    const payload = {
      surveyId: String(this.surveyId),
      serviceLineId: String(this.serviceLineId),
      companyId: String(this.companyId),
      userId: String(this.userId),
      sectionId: String(sectionId)
    };
    this.commonService.httpPostWOHeader(this.myAppUrl + this._saveSurveyUserSectionSettingsUrl,
      JSON.stringify(payload) ,
      this.httpOptions).subscribe(result => {
        //this.successOrFailureMessage = "Saved Successfully";
        //window.setTimeout(() => {
        //  this.successOrFailureMessage = '';
        //}, 1200);
        ////this.toasterService.clear();
        ////this.toasterService.success(this.key_Previous_Tab_Save_Message);
        // ////this.toasterService.success("Saved Successfully");
      });

  }
  SetDate(questionId: any, sectionid: any, isPreview: any) {
    if (!isPreview) {
      var currentSection = this.currentSection;
      var selecteddate = this.surveyForm.value.sections.find((x: any) => x.id === sectionid).questions
        .find((x: any) => x.qid === questionId).value;
      var formateddate = this.dateFormat(selecteddate);
      if (formateddate == "aN/aN/NaN" || formateddate == "01/01/1970") {
        formateddate = '';
      }
      this.surveyForm.value.sections.find((x: any) => x.id === sectionid).questions
        .find((x: any) => x.qid === questionId).value = formateddate;
      this.updateProgressBar();
    }
  }
  dropdownRenderer(params: any) {

    //this.gridApi = params.api;
    //Find RowIndex
    var rowIndex = params.rowIndex;
    //create select element using javascript
    var eSelect = document.createElement("select");
    //Set attributes
    eSelect.setAttribute('class', 'custom-select form-control');
    eSelect.setAttribute('name', params.colDef.field);
    eSelect.setAttribute('id', params.colDef.field + "_" + params.data.sectionId + "_" + params.data.questionId + "_" + params.data.optionId);
    //get the value of the select option
    var value = params.data.displayOrder;
    //create the default option of the select element
    var eOption = document.createElement("option");
    eOption.text = "";
    eOption.value = "";
    eSelect.appendChild(eOption);
    //check field
    if (params.colDef.field == "displayOrder") {

      this.qSections.forEach((q, i) => {
        if (q.id == params.data.sectionId) {
          q.questions.forEach((qs, qsi) => {
            if (qs.type == "RankingSort" && qs.qid == params.data.questionId) {
              let optionIndex: number = 1;
              for (let i = 0; i < qs.rankingSort.length; i++) {
                var eOptionVal = document.createElement("option");
                //Statical set data in grid ComboBox
                //eOptionVal.text = i + 1;
                //eOptionVal.value = i + 1;
                eOptionVal.id = params.colDef.field + "_" + params.data.sectionId + "_" + params.data.questionId + "_" + params.data.optionId + "_" + i.toString();
                var customAttr = document.createAttribute("parentId");
                customAttr.value = params.colDef.field + "_" + params.data.sectionId + "_" + params.data.questionId + "_" + params.data.optionId;
                eOptionVal.setAttributeNode(customAttr);
                eSelect.appendChild(eOptionVal);
              }
              if (qs.value != '') {
                let currentOption = (qs.rankingSort as SurveyEntity.RankingSortOption[])
                  .find(n => n.optionId == params.data.optionId);
                if (currentOption) {
                  //eSelect.value = currentOption.order;
                }




                //eSelect.value = currentOption[0]?.order;
              }
            }
          });
        }
      });
      this.renderer.listen(eSelect, 'change', (event) => {
        let tmpSelectedVal = event.target.value;
        let selectedId = event.target.id;
        for (let i = 0; i < this.gridApi.length; i++) {

          if (this.gridApi[i].sectionId == params.data.sectionId && this.gridApi[i].questionId == params.data.questionId) {

            let ispreview = this.gridApi[i].isPreview;
            //let currentSection = (this.surveyForm.value.sections as SurveyEntity.Section[])
            //  .find(n => n.id == params.data.sectionId);
            //let currentQuestion = (currentSection ? [0].questions as SurveyEntity.Question[])
            //  .find((n:any) => n.qid == params.data.questionId);
            //let currentQuestion = (currentSection && currentSection.length > 0
            //  ? currentSection[0].questions as SurveyEntity.Question[]
            //  : []
            //).find((n: any) => n.qid == params.data.questionId);

            let currentSection = (this.surveyForm.value.sections as SurveyEntity.Section[])
              .find((n: any) => n.id == params.data.sectionId);

            let currentQuestion = currentSection && currentSection.questions
              ? (currentSection.questions as SurveyEntity.Question[]).find((n: any) => n.qid == params.data.questionId)
              : undefined;

            if (currentQuestion) {
              currentQuestion.isPartialAnswer = false;
            }
            let answerArray: SurveyEntity.RankOrderDetails[] = [];
            this.gridApi[i].param.forEachNode(function (node: any) {
              let tmpDDownId = "displayOrder" + "_" + params.data.sectionId + "_" + params.data.questionId + "_" + node.data.optionId;
              var dropDownElement = document.getElementById(tmpDDownId) as HTMLSelectElement;
              if (dropDownElement.selectedIndex != -1) {
                var dropdownValue = dropDownElement.value;
                if (tmpDDownId != selectedId && dropdownValue === tmpSelectedVal) {
                  dropDownElement.selectedIndex = -1;
                }
              }

              if (!ispreview && dropDownElement.selectedIndex == -1 || dropDownElement.selectedIndex == 0) {
                if (currentQuestion) {
                  currentQuestion.isPartialAnswer = true;
                }
              }
              if (!ispreview) {
                answerArray.push({ optionId: +node.data.optionId, rank: +dropDownElement.value })
              }

            });
            if (!ispreview) {
              //currentQuestion.isPartialAnswer = JSON.stringify(answerArray);
            }

          }
        }
        this.markAsFormChange();
      });

    }
    return eSelect;
  }
  onTabChange($event: any) {
    if ($event.heading === "Questionnaire") {
      this.isQuestionnaire = false;
    }

    if (!this.surveyForm.value.isPreview) {
      if ($('[formarrayname="sections"]').find('a.active').find('.bRed').length == 0) {
        if (this.surveyForm.value.isautosave && this.surveyForm.controls.flagChanges.touched) {
          //this.isQuestionnaireTabActive = true;
          this.formchanged = false;
          let prevTabId = Number($('[formarrayname="sections"]')?.find('a.active')?.attr('id')?.split('-')[0]);
          var data: SurveyEntity.MetaForm = {
            responseId: Number(this.surveyForm.value.responseId),
            serviceLineId: Number(this.surveyForm.value.serviceLineId),
            companyId: Number(this.surveyForm.value.companyId),
            /*userId: Number(this.EncrDecr.get(localStorage.getItem('userId'))),*/
            userId: Number(this.surveyForm.value.userId),
            surveyId: Number(this.surveyForm.value.surveyId),
            surveytitle: this.surveyForm.value.surveytitle,
            surveydescription: "",
            surveytype: this.surveyForm.value.surveytype,
            isautosave: this.surveyForm.value.isautosave == true,
            isprogressbar: this.surveyForm.value.isprogressbar,
            perpage: Number(this.surveyForm.value.perpage),
            isPreview: this.isPreview,
            sections: (this.surveyForm.value.sections as SurveyEntity.Section[]).filter(n => n.id === prevTabId),
            isforcefullysubmitted: false
          }
          var userId = localStorage.getItem('userId') ?? '-1';
          debugger
          this.http.post(this.myAppUrl + this._SurveySaveResponseUrl, JSON.stringify(data), this.httpOptions).subscribe(result => {
            if (this.userId == '-1' || this.EncrDecr.get(userId)) {
              var uId = result;
              var survId = result;
              var survIdString = 'surveyId_' + survId.toString();
              var localStorageString = localStorage.getItem(survIdString);
              if (localStorageString === '' || localStorageString === null) {
                localStorage.setItem(survIdString, uId.toString());
                var newLocalStorageString = localStorage.getItem(survIdString);
              }



              var sForm1 = this.surveyForm;
              this.surveyForm.setValue({
                userId: uId.toString(),
                responseId: this.surveyForm.value.responseId,
                surveyId: this.surveyForm.value.surveyId,
                serviceLineId: this.surveyForm.value.serviceLineId,
                companyId: this.surveyForm.value.companyId,
                surveytitle: this.surveyForm.value.surveytitle,
                surveydesctiption: this.surveyForm.value.surveydesctiption,
                surveytype: this.surveyForm.value.surveytype,
                isautosave: this.surveyForm.value.isautosave,
                isprogressbar: this.surveyForm.value.isprogressbar,
                perpage: this.surveyForm.value.perpage,
                sections: this.surveyForm.value.sections,
                flagChanges: this.surveyForm.value.flagChanges,
                isPreview: this.surveyForm.value.isPreview
              });
              var sForm = this.surveyForm;
              //this.userId = uId;
            }

            this.surveyForm.controls.flagChanges.markAsUntouched();
            //this.toasterService.clear();
            //this.toasterService.success(this.key_Previous_Tab_Save_Message);
          });
        }
      }
      else {
        //this.toasterService.clear();
        //this.toasterService.error("Please resolve all validation errors before save or submit", "Errors in Page");
      }
    }
  }

  onSelect($event: any) {
    this.attemptedQuestionCount = 0;
    var section = this.surveyForm.value.sections;
    var tmpIsPBar = false;
    tmpIsPBar = this.surveyForm.value.isprogressbar;
    if (tmpIsPBar) {
      section.forEach((q: any, i: any) => {
        if (q.isHide != true) {
          q.questions.forEach((qs: any, qsi: any) => {
            this.setProgressBarAttemptedQuesCount(qs);
          });
        }
      });
      this.attemptedPercentage = Math.round((this.attemptedQuestionCount / this.totalQuestionCount) * 100);
    }

    this.sectionDocs.patchValue({
      sectionName: $event.heading,
      sectionId: $event.id
    });
    this.selectedSection.Name = $event.heading;
    this.selectedSection.Id = $event.id;

    this.isQuestionnaire = true;

  }
  onRankingSortGridReady(params: any, sectionId: any, questionId: any, isPreview: any) {

    params.api.sizeColumnsToFit();

    this.gridApi.push({ param: params.api, sectionId: sectionId, questionId: questionId, isPreview: isPreview });

  }
  colDefsRankingSort = [
    { headerName: 'QuestionId', field: 'questionId', hide: true, width: 0 },
    { headerName: 'SectionId', field: 'sectionId', hide: true, width: 0 },
    { headerName: 'OptionId', field: 'optionId', hide: true },
    { headerName: '', field: '', width: 35, rowDrag: true, resizable: true },
    { headerName: '', field: 'displayOrder', cellRenderer: this.dropdownRenderer.bind(this), width: 100, resizable: true },
    { headerName: '', field: 'name', width: 800, resizable: true, tooltip: (params: any) => '' + params.value },
  ];

  updateProgressBar() {

    if (this.surveyData.isprogressbar) {
      this.attemptedQuestionCount = 0;
      this.attemptedPercentage = 0;
      this.surveyForm.value.sections.forEach((q: any, i: any) => {
        if (q.isHide != true) {
          q.questions.forEach((qs: any, qsi: any) => {
            this.setProgressBarAttemptedQuesCount(qs);
          });
        }
      });
      this.attemptedPercentage = Math.round((this.attemptedQuestionCount / this.totalQuestionCount) * 100);
    }
  }
  dateFormat(date: any) {
    var date1 = new Date(date);
    var month = ("0" + (date1.getMonth() + 1)).slice(-2);
    var day = ("0" + date1.getDate()).slice(-2);
    var formattedDate = [day, month, date1.getFullYear()].join("/");
    return formattedDate;

  }


  onNext(form: any) {
    let data = JSON.stringify(form.value);
    var tabs = this.surveyData.metaBody.sections;
    if (tabs[this.tabIndex].type === "Questionnaire") {
      if (!this.isPreview) {
        this.requiredValidationTriggered = true;
        let currentSection: SurveyEntity.Section[];
        currentSection = form.value.sections
          .filter((wh: SurveyEntity.Section) => wh.type == 'Questionnaire' && wh.id == this.activeTabId)
          .sort((a: SurveyEntity.Section, b: SurveyEntity.Section) => a.qSOrder - b.qSOrder);
        this.currentSection = currentSection;

        var isContinueToSave = this.ValidateRowLevelMandatory(currentSection[0]);
        if (isContinueToSave) {
          this.requiredValidationTriggered = false;
        }
        else {
          this.requiredValidationTriggered = true;
          ////this.toasterService.clear();

          var language = this.languageCode;
          var nextValidation = this.key_Next_Validation_Message;

          if (language === 'it') {
            this.key_Next_Validation_Message = 'Si prega di rispondere a tutte le domande obbligatorie. Evidenziato in rosso.';
          }

          ////this.toasterService.error(this.key_Next_Validation_Message);
          return;
        }
      }
    }
    if (this.OptionAndSectionList != null && this.OptionAndSectionList.length > 0) {
      let HideSectionValue: boolean = false;

      while (!HideSectionValue) {
        var nextTabOrder = this.tabIndex + 1;
        if (tabs.length > nextTabOrder) {
          var nextTabObject = tabs[nextTabOrder];
          this.activeTabId = tabs[nextTabOrder].id;
          window.scroll(0, 0);
          this.tabIndex++;
          if (nextTabObject.type === "Questionnaire") {
            let tempcurrentSection: SurveyEntity.Section[];
            tempcurrentSection = (form.value.sections as SurveyEntity.Section[])
              .filter(wh => wh.type === 'Questionnaire' && wh.id === this.activeTabId)
              .sort((a, b) => a.qSOrder - b.qSOrder);
            if (tempcurrentSection[0].isHide != null && tempcurrentSection[0].isHide == true) {
              HideSectionValue = false;
            }
            else {
              HideSectionValue = true;
            }

            this.isQuestionnaireTabActive = true;

          } else {
            HideSectionValue = true;
            this.isQuestionnaireTabActive = false;
          }
        }
      }
      var nextTabOrder = this.tabIndex + 1;
      var nextTabObject = tabs[nextTabOrder];
      if (nextTabObject.type === "Questionnaire") {

        var isLastTab: number = this.tabIndex + 1;
        var isLast: boolean = false;

        let lastIndex = isLastTab;
        let isActiveLastTab = false;
        while (!isLast && isLastTab < this.surveyData.metaBody.sections.length) {

          let currentSectionId = this.surveyData.metaBody.sections[isLastTab].id;

          let formcurrentSection: SurveyEntity.Section[];
          formcurrentSection = (form.value.sections || [])
            .filter((wh: SurveyEntity.Section) => wh.type === 'Questionnaire' && wh.id === currentSectionId)
            .sort((a: SurveyEntity.Section, b: SurveyEntity.Section) => a.qSOrder - b.qSOrder);

          //lastSectionId = formcurrentSection[0].id;
          if (formcurrentSection[0].isHide != null && formcurrentSection[0].isHide == true && this.surveyData.metaBody.sections.length - 1 === isLastTab) {
            //this.lastTab = true;
            isLast = false;
            lastIndex = isLastTab;
            isActiveLastTab = true;
          }
          if (formcurrentSection[0].isHide == true) {
            isLast = false;
          }

          else {
            //this.lastTab = false;
            isLast = true;

          }
          isLastTab = isLastTab + 1;
        }
        if ((isActiveLastTab == true) || this.surveyData.metaBody.sections.length === this.tabIndex + 1) {
          this.lastTab = true;
        }
        else {
          this.lastTab = false;
        }
      }
      else {
        var isLastTab: number = this.tabIndex + 1;

        if (this.surveyData.metaBody.sections.length === isLastTab) {
          this.lastTab = true;
        } else {
          this.lastTab = false;
        }
      }

    }
    else {
      //this.requiredValidationTriggered = false;
      var nextTabOrder = this.tabIndex + 1;
      if (tabs.length > nextTabOrder) {
        var nextTabObject = tabs[nextTabOrder];
        this.activeTabId = tabs[nextTabOrder].id;
        window.scroll(0, 0);
        this.tabIndex++;
        if (nextTabObject.type === "Questionnaire") {
          this.isQuestionnaireTabActive = true;

        } else {
          this.isQuestionnaireTabActive = false;
        }

      }

      var isLastTab: number = this.tabIndex + 1;
      var isLastTab = this.tabIndex + 1;
      if (this.surveyData.metaBody.sections.length === isLastTab) {
        this.lastTab = true;
      } else {
        this.lastTab = false;
      }

    }

    if (this.surveyProviderBucketSettingsList.length > 0) {
      var uid = this.userId;
      var userBucketSettings = (this.surveyProviderBucketSettingsList as surveyProviderBucketSetting[])
        .filter(x => x.entityTypeName.toLowerCase() === 'user text' && x.entityId.toString() === uid);
      var questionBucketSettings: surveyProviderBucketSetting[] = [];

      if (userBucketSettings.length > 0) {
        userBucketSettings.forEach((u: any, i: any) => {
          var qBucketSettings = (this.surveyProviderBucketSettingsList as surveyProviderBucketSetting[])
            .filter(x => x.entityTypeName.toLowerCase() === 'question text' && x.bucketId === u.bucketId);
          qBucketSettings.forEach((qb: any, i: any) => {
            questionBucketSettings.push(qb);
          });
        });

        var orderedBucketSettings = (questionBucketSettings as surveyProviderBucketSetting[])
          .filter(x => x.entityTypeName.toLowerCase() === 'question text')
          .sort((a, b) => b.entityId - a.entityId);
        var finalQuestion = orderedBucketSettings[0];
        var tabIndex = this.tabIndex;
        // var nextTabIndex = tabIndex + 1;
        var nextSection = tabs[tabIndex];
        var finalSection = (nextSection.questions as SurveyEntity.Question[])
          .filter(x => x.qid === finalQuestion.entityId);

        if (finalSection.length > 0) {
          this.lastTab = true;
        }
      }
    }
  }
  onCheckChange(event: any, option: SurveyEntity.Option, question: any, surveyForm: any, section: any) {


    if (event.target.checked) {

      //If None of the above option is selected, make sure to grey out / disable the other options
      if (option.name.toLowerCase().indexOf('none') > -1) {
        var surveyF = this.surveyForm;
        this.surveyForm.value.sections.forEach((s: any, i: any) => {
          s.questions.forEach((q: any, i: any) => {
            if (q.multipleChoice !== null) {
              q.multipleChoice.forEach((o: any, i: any) => {
                if (o.optionId !== option.optionId) {
                  var optId = "opt_" + o.optionId;
                  var id = document.getElementById(optId);
                  //id.disabled = true;
                }
              });
            }

          });
        });

      }

      question.value.value = question.value.value ? question.value.value.concat(',', option.optionId.toString()) : option.optionId.toString();

      if (this.OptionAndSectionList != null && this.OptionAndSectionList.length > 0) {
        if (question.value.type.toLowerCase() == 'multiplechoice') {
          this.setOptionAndSectionSettingForMC(surveyForm, question, section, question.value.value)
        }
        else {
          this.setOptionAndSectionSetting(question.value.value, surveyForm, question, section)
        }
      }
      if (this.AdaptiveSettings != null && this.AdaptiveSettings.length > 0) {
        if (question.value.type.toLowerCase() == 'multiplechoice') {
          this.setAdaptiveSettingForMC(surveyForm, question, section, question.value.value);
        }
        else {
          this.setAdaptiveSetting(question.value.value, surveyForm, question, section);
        }
      }
      if (this.DependentOptionList != null && this.DependentOptionList.length > 0) {
        if (question.value.type.toLowerCase() == 'multiplechoice') {

          this.setDependentOptionSettingForMC(question.value.value, surveyForm, question, section, this.mcDependentOptionSetting);
        }
        else {
          this.setDependentOptionSetting(question.value.value, surveyForm, question, section);
        }
      }
    }
    else {

      //If None of the above option is de-selected, make sure to enable the other options
      if (option.name.toLowerCase().indexOf('none') > -1) {
        this.surveyForm.value.sections.forEach((s: any, i: any) => {
          s.questions.forEach((q: any, i: any) => {
            if (q.multipleChoice !== null) {
              q.multipleChoice.forEach((o: any, i: any) => {
                if (o.optionId !== option.optionId) {
                  var optId = "opt_" + o.optionId;
                  var id = document.getElementById(optId);
                  //if (id && id.disabled) {
                  //  id.disabled = false;

                  //}
                }
              });
            }

          });
        });

      }

      let values: any[] = question.value.value.split(',');
      question.value.value = values.filter(n => n != option.optionId.toString()).join(',');
      if (question.value.type.toLowerCase() == 'multiplechoice') {
        if (this.OptionAndSectionList != null && this.OptionAndSectionList.length > 0) {
          this.setOptionAndSectionSettingForMC(surveyForm, question, section, question.value.value)
        }
        if (this.AdaptiveSettings != null && this.AdaptiveSettings.length > 0) {
          if (question.value.type.toLowerCase() == 'multiplechoice') {
            this.setAdaptiveSettingForMC(surveyForm, question, section, question.value.value);
          }
        }
        if (this.DependentOptionList != null && this.DependentOptionList.length > 0) {
          if (question.value.type.toLowerCase() == 'multiplechoice') {
            this.setDependentOptionSettingOnUncheckMC(question, option, surveyForm, section);
          }
          else {
            this.setDependentOptionSetting(question.value.value, surveyForm, question, section);
          }
        }
      }

      if (option.isTextBoxRequired) {
        option.showAdditionalTextBox = false;
      }

    }



    this.markAsFormChange();
    this.updateProgressBar();
    if (event.target.checked && option.evaluateAndExit) {
      this.updateActiveSection();

    }
    else if (event.target.checked && option.isTextBoxRequired) {
      option.showAdditionalTextBox = true;
    }
  }
  private setDependentOptionSettingOnUncheckMC(question: any, option: SurveyEntity.Option, surveyForm: any, section: any) {
    let tmpSelectedOptionList: string[] = [];
    tmpSelectedOptionList = question.value.value.split(',');
    let lastSelectedQuestionId = 0;
    let lastSelectedSectionId = 0;
    if (tmpSelectedOptionList.length == 1 && tmpSelectedOptionList[0] == "") {
      lastSelectedQuestionId = this.mcDependentOptionSetting[0].actionByQuestionId;
      lastSelectedSectionId = this.mcDependentOptionSetting[0].actionBySectionId;
    }
    if (this.mcDependentOptionSetting == undefined || this.mcDependentOptionSetting.length <= 0) {
      this.mcDependentOptionSetting = [];
    }

    //Remove the dependencies for the unchecked options from the global list
    let tmpOptionId = option.optionId;
    this.mcDependentOptionSetting = this.mcDependentOptionSetting.filter(x => x.optionId != tmpOptionId);

    //Setting display equals to true for dependent MC/SR questions on unchecking the last checkbox
    if (this.mcDependentOptionSetting.length == 0 && tmpSelectedOptionList[0] == "") {

      var sections = this.surveyForm.value.sections;
      sections.forEach((uq: any, uqi: any) => {
        if (uq.id == lastSelectedSectionId) {
          let Question: SurveyEntity.Question[];
          Question = Array.isArray(uq.questions) ? uq.questions : Array.from(uq.questions);
          Question.forEach((q, qi) => {
            if ((q.type.toLowerCase() == 'multiplechoice') && (q.qid) == lastSelectedQuestionId) {
              q.multipleChoice.forEach((o: any, oi: any) => {
                o.display = true;
              });
            }

            if ((q.type.toLowerCase() == 'multipleresponse') && (q.qid) == lastSelectedQuestionId) {
              q.multipleResponse.forEach((o: any, oi: any) => {
                o.display = true;
              });
            }

          });
        }
      });
    }
    else {
      this.setDependentOptionSettingForMC(question.value.value, surveyForm, question, section, this.mcDependentOptionSetting);
    }
  }

  setDependentOptionSettingForMC(optionId: any, surveyForm1: any, question: any, section: any, tmpMcDependentSettingList: any) {
    let currentDependentSetting: SurveyEntity.DependentQuestionOptionSettings[];
    let selectedOptionList: string[] = [];
    selectedOptionList = question.value.value.split(',');
    var i: number;
    var tmpSectionId: number;
    tmpSectionId = section.value.id;
    if (tmpMcDependentSettingList == undefined || tmpMcDependentSettingList.length <= 0) {
      this.mcDependentOptionSetting = [];
    }
    if (selectedOptionList.length > 0) {
      for (i = 0; i <= selectedOptionList.length; i++) {
        optionId = selectedOptionList[i];

        currentDependentSetting = (this.DependentOptionList as SurveyEntity.DependentQuestionOptionSettings[])
          .filter(n => n.questionId == question.value.qid && n.sectionId == tmpSectionId && n.optionId == optionId);

        if (currentDependentSetting.length > 0) {
          currentDependentSetting.forEach((element) => {
            if (!this.mcDependentOptionSetting.includes(element))
              this.mcDependentOptionSetting.push(element);
          });
        }
      }

      if (this.mcDependentOptionSetting.length > 0) {
        var section = this.surveyForm.value.sections;
        section.forEach((q: any, i: any) => {
          q.questions.forEach((qs: any, qsi: any) => {
            let updateCascadeSetting: SurveyEntity.DependentQuestionOptionSettings[];
            updateCascadeSetting = (this.mcDependentOptionSetting as SurveyEntity.DependentQuestionOptionSettings[])
              .filter(n => n.actionByQuestionId == qs.qid && n.actionBySectionId == q.id);

            if ((qs.type.toLowerCase() == "multiplechoice") && updateCascadeSetting.length >= 1) {
              qs.multipleChoice.forEach((o: any, oi: any) => {
                let options = updateCascadeSetting.filter(x => x.actionByOptionId == o.optionId);
                if (options != null && options.length >= 1) {
                  o.display = true;
                }
                else {
                  o.display = false;
                }
              });
              this.filledDependentOption = true;

            }

            if ((qs.type.toLowerCase() == "multipleresponse") && updateCascadeSetting.length >= 1) {
              qs.multipleResponse.forEach((o: any, oi: any) => {
                let options = updateCascadeSetting.filter(x => x.actionByOptionId == o.optionId);
                if (options != null && options.length >= 1) {
                  o.display = true;
                }
                else {
                  o.display = false;

                }
              });
              this.filledDependentOption = true;
            }

          });
        });
      }

    }

  }

  onSelectChange(event: any, surveyForm: any, question: any, section: any) {
    this.filledDependentOption = false;
    // change survay form value according the slection
    surveyForm.value.sections.find((x: any) => x.id === section.value.id).questions
      .find((x: any) => x.qid === question.value.qid).value = event.target.options[event.target.options.selectedIndex].value.split(': ')[1];
    this.updateProgressBar();
    if (this.AdaptiveSettings != null && this.AdaptiveSettings.length > 0) {
      this.setAdaptiveSetting(event.target.value.split(': ')[1], surveyForm, question, section);
    }
    if (this.DependentOptionList != null && this.DependentOptionList.length > 0) {
      this.setDependentOptionSetting(event.target.value.split(': ')[1], surveyForm, question, section);
    }
    if (this.OptionAndSectionList != null && this.OptionAndSectionList.length > 0) {
      this.setOptionAndSectionSetting(event.target.value.split(': ')[1], surveyForm, question, section)
    }
    if (this.MergeCodeSettings != null && this.MergeCodeSettings.length > 0) {
      this.setMergeCodeSetting(event.target.value.split(': ')[1], surveyForm, question, section);
    }
  }
  onRankingRowSelected(params: any) {
    this.updateProgressBar();
  }
  filterOptionItems(pickList: SurveyEntity.PickListItem[]): SurveyEntity.PickListItem[] {
    return pickList.filter(x => x.display != false);
  }

  onKeypressEvent(event: any) {
    if (event.target.value.length >= event.target.maxLength) {
      event.target.parentElement.parentElement.lastChild.style.display = 'block';
    } else {
      event.target.parentElement.parentElement.lastChild.style.display = 'none';
    }
  }

  onDragEnd(params: any, sectionId: any, questionId: any, isPreview: any) {
    for (let i = 0; i < this.gridApi.length; i++) {
      if (this.gridApi[i].sectionId == sectionId && this.gridApi[i].questionId == questionId) {
        this.gridApi[i].params = params.api;
        let currentSection = (this.surveyForm.value.sections as SurveyEntity.Section[])
          .filter(n => n.id == this.gridApi[i].sectionId);

        let currentQuestion = (currentSection[0].questions as SurveyEntity.Question[])
          .filter(n => n.qid == this.gridApi[i].questionId);
        currentQuestion[0].isPartialAnswer = false;
        let answerArray: SurveyEntity.RankOrderDetails[] = [];
        let rank
        this.gridApi[i].param.forEachNode(function (node: any) {

          let tmpDDownId = "displayOrder" + "_" + sectionId + "_" + questionId + "_" + node.data.optionId;
          let optionIndex = node.rowIndex + 1; //node.id;
          let ddElement = document.getElementById(tmpDDownId) as HTMLSelectElement;

          ddElement.value = optionIndex;
          //ddElement.options[optionIndex].selected = true;


          if ((!isPreview) && ddElement.selectedIndex == -1 || ddElement.selectedIndex == 0) {
            currentQuestion[0].isPartialAnswer = true;
          }
          if (!isPreview) {

            answerArray.push({ optionId: +node.data.optionId, rank: +ddElement.value })
          }
        });
        if (!isPreview) {
          currentQuestion[0].value = JSON.stringify(answerArray);
        }
      }
    };
    this.markAsFormChange();
    this.updateProgressBar();
  }
  onPrev(form: any) {
    if (this.OptionAndSectionList != null && this.OptionAndSectionList.length > 0) {
      let HideSectionValue: boolean = false;
      var tabs = this.surveyData.metaBody.sections;
      while (!HideSectionValue) {
        var prevTabOrder = this.tabIndex - 1;
        if (tabs.length > prevTabOrder) {
          var nextTabObject = tabs[prevTabOrder];
          this.activeTabId = tabs[prevTabOrder].id;
          window.scroll(0, 0);
          this.tabIndex--;
          if (nextTabObject.type === "Questionnaire") {
            let tempcurrentSection: SurveyEntity.Section[];
            tempcurrentSection = (form.value.sections as SurveyEntity.Section[])
              .filter(wh => wh.type === 'Questionnaire' && wh.id === this.activeTabId)
              .sort((a, b) => a.qSOrder - b.qSOrder);
            this.currentSection = tempcurrentSection;

            if (tempcurrentSection[0].isHide != null && tempcurrentSection[0].isHide == true) {
              HideSectionValue = false;
            }
            else {
              HideSectionValue = true;
            }

            this.isQuestionnaireTabActive = true;

          } else {
            HideSectionValue = true;
            this.isQuestionnaireTabActive = false;
          }
        }
      }


      this.lastTab = false;
    }
    else {
      var prevTabOrder = this.tabIndex - 1;
      var tabs = this.surveyData.metaBody.sections;

      if (tabs.length > prevTabOrder) {
        var nextTabObject = tabs[prevTabOrder];
        this.activeTabId = tabs[prevTabOrder].id;
        window.scroll(0, 0);
        this.tabIndex--;
        if (nextTabObject.type === "Questionnaire") {
          this.isQuestionnaireTabActive = true;
        } else {
          this.isQuestionnaireTabActive = false;
        }
      }
      this.lastTab = false;
    }
  }
  onDocselect($event: any) {
    this.isQuestionnaire = true;
    //this.selectedSection.Name = this.qSections[0].name;
    var activeElements = $('[formarrayname="sections"]').find('a.active');
    if (activeElements != undefined && activeElements != null) {
      let idAttribute = activeElements.attr('id');
      if (idAttribute != undefined && idAttribute != null) {
        let splitValue = idAttribute.split('-');
        if (splitValue.length > 0)
          this.selectedSection.Id = Number(splitValue[0]);
      }
    }
  }
  setRankingSortOrder(question: SurveyEntity.Question) {
    let answerArray: SurveyEntity.RankOrderDetails[] = [] = JSON.parse(question.value);
    answerArray.forEach(item => {
      let currentOption = (question.rankingSort as SurveyEntity.RankingSortOption[])
        .filter(n => n.optionId === item.optionId);
      currentOption[0].order = item.rank;
    });
    question.rankingSort = (question.rankingSort as SurveyEntity.RankingSortOption[])
      .slice()
      .sort((a, b) => a.order - b.order);
  }
  setSliderValue(range: SurveyEntity.GradingRangeDetails[]) {
    let minRange = range.reduce((min, p) => p.min < min ? p.min : min, range[0].min);
    let maxRange = range.reduce((max, p) => p.max > max ? p.max : max, range[0].max);
    let minDesc = "";
    let maxDesc = "";
    let tickDesc = "";
    range.forEach(item => {
      if (item.min === minRange) {
        minDesc = item.rangeDescription;
      }
      if (item.max === maxRange) {
        maxDesc = item.rangeDescription;
      }
    });

    let tmpArray = range;

    const newOptions: Options = Object.assign({}, this.options);
    newOptions.ceil = maxRange;
    newOptions.floor = minRange;
    newOptions.translate = (value: number, label: LabelType): string => {
      this.markAsFormChange();
      this.updateProgressBar();
      switch (label) {
        case LabelType.Floor:
          return '<b>' + minDesc + ': </b> ' + value;
        case LabelType.Ceil:
          return '<b>' + maxDesc + ': </b> ' + value;
        default:
          tmpArray.forEach(item => {
            if (value >= item.min && value <= item.max) {
              tickDesc = item.rangeDescription;
            }
          });
          return '<b>' + tickDesc + ': </b> ' + value;
      }
    }
    this.options = newOptions;

  }
  fetchSectionDocuments() {
    this.sectionDocs.controls['documentname'].reset();
    this.sectionDocs.controls['file'].reset();
    this.http.get<SurveyEntity.uploadedDocuments[]>(this.myAppUrl + this._fetchsectiondocs, {
      params: {
        'surveyId': this.surveyId.toString(),
        'serviceLineId': this.serviceLineId.toString(),
        'companyId': this.companyId.toString(),
        'sectionId': this.selectedSection.Id.toString(),
        'userId': this.EncrDecr.get(localStorage.getItem('userId') ?? ""),
      }
    }).subscribe(data => {
      this.sectionDocuments = data;
    });
  }
  SaveAcceptChanges($event: any, type: any, sectionId: any) {
    this.surveyData.metaBody.sections.forEach((s: any, i: any) => {
      if (s.id == sectionId) {
        let tempIsConfirmed = true;
        if ($event.target.checked && type == 'AT') {
          tempIsConfirmed = true;
        }
        if ($event.target.checked && type == 'NAT') {
          tempIsConfirmed = false;
        }
        this.http.post<SurveyEntity.Meta>(this.myAppUrl + this._updateConfirmation, '', {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          },
          params: {
            'surveyId': this.surveyId.toString(),
            'serviceLineId': this.serviceLineId.toString(),
            'companyId': this.companyId.toString(),
            'sectionId': s.id.toString(),
            'userId': this.EncrDecr.get(localStorage.getItem('userId') ?? ""),
            'isConfirmed': tempIsConfirmed.toString()
          }
        }).subscribe(data => {

          //s.isConfirmed = tempIsConfirmed;
        });
      }
      if (s.isConfirmationRequires && (!s.isConfirmed)) {
        this.isAllSectionConfirmed = false;
      }
      else if (s.isConfirmationRequires && (s.isConfirmed)) {
        this.isAllSectionConfirmed = true;
      }
    });
  }
  loadHeaders(htmlStr: string, section: SurveyEntity.Section, question: SurveyEntity.Question) {



    if ($("#" + section.id + "_" + question.qid).find('thead tr').length == 0) {
      $("#" + section.id + "_" + question.qid).find('thead').append(htmlStr);
    }
  }
  initSection(sections: SurveyEntity.Section[]): FormArray<FormGroup> {
    const sectionArray = new FormArray<FormGroup>([]);
    sections.forEach((section) => {
      sectionArray.push(new FormGroup({
        id: new FormControl(section.id),
        name: new FormControl(section.name),
        description: new FormControl(section.description),
        order: new FormControl(section.order),
        type: new FormControl(section.type),
        acceptedText: new FormControl(section.acceptedText ?? ''), // <-- add this
        notAcceptedText: new FormControl(section.notAcceptedText ?? ''), // <-- add this
        questions: this.intializeQuestions(section.questions),
        isShowSection: new FormControl(section.isShowSection),
        isHide: new FormControl(section.isHide)
      }));
    });
    return sectionArray;
  }
  intializeQuestions(qs: SurveyEntity.Question[]): FormArray<FormGroup> {
    const questionArray = new FormArray<FormGroup>([]);
    qs.forEach((question) => {
      questionArray.push(
        new FormGroup({
          qid: new FormControl(question.qid),
          qrid: new FormControl(question.qrid),
          text: new FormControl(question.text),
          order: new FormControl(question.order),
          type: new FormControl(question.type),
          value: new FormControl(question.value),
          isRequired: new FormControl(question.isRequired),
          isPartialAnswer: new FormControl(question.isPartialAnswer),
          displayNumberText: new FormControl(question.displayNumberText ?? ''), // <-- add default
          questionPrefix: new FormControl(question.questionPrefix ?? ''),
          width: new FormControl(question.width ?? 0),
          maxCharacterLength: new FormControl(question.maxCharacterLength ?? 0),
          slider: new FormControl(question.slider ?? []), // <-- add default
          pickList: new FormControl(question.pickList ?? []), // <-- add default
          textInput: new FormControl(question?.textInput ?? ''), // <-- add default
          constantSum: new FormControl(question.constantSum ?? ''), // <-- add default
          description: new FormControl(question.description ?? ''), // <-- add default
          rankingSort: new FormControl(question.rankingSort ?? []), // <-- add default
          defaultValue: new FormControl(question.defaultValue ?? ''), // <-- add default
          multipleChoice: new FormControl(question.multipleChoice ?? []), // <-- add default
        })
      );
    });
    return questionArray;
  }
  intializeRowFields(matrix: SurveyEntity.Matrix): FormArray<FormGroup> {
    const rowArray = new FormArray<FormGroup>([]);
    matrix.rowdataFields.forEach((rowField) => {
      rowArray.push(new FormGroup({
        rowItemId: new FormControl(rowField.rowItemId),
        rowText: new FormControl(rowField.rowText),
        cellReferences: new FormControl(rowField.cellReferences)
      }));
    });
    return rowArray;
  }
  intializeColumnFields(matrix: SurveyEntity.Matrix): FormArray<FormGroup> {
    const colArray = new FormArray<FormGroup>([]);
    if (matrix && Array.isArray(matrix.columnFields)) {
      for (const columnField of matrix.columnFields) {
        colArray.push(new FormGroup({
          columnItemId: new FormControl(columnField?.columnItemId ?? null),
          columnHeaderText: new FormControl(columnField?.columnHeaderText ?? ''),
          columnType: new FormControl(columnField?.columnType ?? ''),
          controlType: new FormControl(columnField?.controlType ?? ''),
          defaultValue: new FormControl(columnField?.defaultValue ?? ''),
          dataSource: new FormControl(columnField?.dataSource ?? []),
          isRequired: new FormControl(columnField?.isRequired ?? false),
          isEnabled: new FormControl(columnField?.isEnabled ?? true),
          order: new FormControl(columnField?.order ?? 0),
          min: new FormControl(columnField?.min ?? null),
          max: new FormControl(columnField?.max ?? null)
        }));
      }
    }
    return colArray;
  }
  intializeColumns(matrix: SurveyEntity.Matrix): FormArray {
    const colArray = new FormArray<FormGroup>([]);
    matrix.columns.forEach((column: any, index: any) => {
      colArray.push(new FormGroup({
        name: new FormControl(column.name),
        childColumns: new FormControl(column.childColumns),
        colspan: new FormControl(column.colspan)
      }));
    });
    return colArray;
  }
  getIndex(row: SurveyEntity.RowdataField, column: SurveyEntity.ColumnField) {
    let index = row.cellReferences.findIndex(n => n.cellAddress.length > 0 && n.cellAddress[0] == row.rowItemId && n.cellAddress[1] == column.columnItemId);
    return index;
  }
  setValue(row: SurveyEntity.RowdataField, column: SurveyEntity.ColumnField) {
    if (column.controlType == 'Text' || column.controlType == 'Label' || column.controlType == 'TextArea') {
      let obj1 = row.cellReferences.find(n => n.cellAddress.length > 0 && n.cellAddress[0] == row.rowItemId && n.cellAddress[1] == column.columnItemId);
      return obj1?.value;
    }
  }

  ExitFromSurvey() {
    if (this.surveyData.fromModule == "Provider") {
      this._router.navigate(['../provider']);
    }
    else if (this.surveyData.fromModule == "Survey") {
      this._router.navigate(['../survey']);
    }
    else if (this.surveyData.fromModule == "Report") {
      this._router.navigate(['../report', { surveyId: this.surveyId, companyId: this.companyId, serviceLineId: this.serviceLineId }]);
    }
    else if (this.surveyData.fromModule == "programOverview") {
      this._router.navigate(['../programoverview'], { queryParams: { 'productId': this.serviceLineId } });
    }

  }

  submitSurvey(form: any) {
    this.surveySubmitTriggered = true;
    setTimeout(() => {
      if ($(document).find('.bReq').length == 0) {
        let data = JSON.stringify(form.value);
        this.http.post(this.myAppUrl + this._SurveySubmitSurveyUrl, data, this.httpOptions).subscribe(result => {
          if (result == "true") {
            this.successOrFailureMessage = "Survey has been submitted successfully.";
            window.setTimeout(() => {
              this.successOrFailureMessage = '';
              this._router.navigate(['../provider']);
            }, 1200);

          }
        });
      }
      else {
        //this.toasterService.clear();
        //this.toasterService.error("Please enter all the required fields before submit.", "Required Field Validation");
      }
    }, 1000);
  }
  ValidateRowLevelMandatory(currentSection: any) {
    var isContinueToSave = true;
    currentSection.questions.forEach((qs: any, qsi: any) => {
      if (qs.isShow !== false) {
        if (qs.type == "Matrix" && qs.isRequired) {
          if (qs.matrix.isEveryRowMandatory) {
            qs.matrix.rowdataFields.forEach((r: any, ri: any) => {
              if (!isContinueToSave) return;
              var count = 0;
              r.cellReferences.forEach((cell: any, cr: any) => {
                if (!cell.value && cell.value !== 'True' && cell.value !== 'true')
                  count++;
              });
              if (r.cellReferences.length == count) {
                isContinueToSave = false;
                qs.isAnswered = false;
              }
            });
          }
          else {
            let isMatrixQsAttempted = false;
            if (!isMatrixQsAttempted) {
              qs.matrix.rowdataFields.forEach((r: any, ri: any) => {
                if (!isMatrixQsAttempted) {
                  r.cellReferences.forEach((cell: any, cr: any) => {
                    if (!isMatrixQsAttempted) {
                      if (cell.value != '')
                        isMatrixQsAttempted = true;
                    }
                  });
                }
              });
            }
            if (!isMatrixQsAttempted) {
              isContinueToSave = false; qs.isAnswered = false;
            }
          }
        }
        if (qs.type == "ConstantSum") {

          let CategoryValue = qs.matrix.headerValue;
          let SubCategoryColumnId = 0;

          let isMatrixQsAttempted: boolean = false;
          if (!isMatrixQsAttempted) {
            qs.matrix.rowdataFields.forEach((r: any, ri: any) => {
              if (!isMatrixQsAttempted) {
                r.cellReferences.forEach((cell: any, cr: any) => {
                  if (!isMatrixQsAttempted) {
                    if (cell.value != '' && cell.value != null)
                      isMatrixQsAttempted = true;
                  }
                });
              }
            });
          }
          if (!isMatrixQsAttempted && qs.isRequired) {
            isContinueToSave = false; qs.isAnswered = false;
          }


          if (isMatrixQsAttempted) {
            qs.matrix.columnFields.forEach((c: any, ci: any) => {
              if (c.controlType == 'Text') {
                SubCategoryColumnId = c.columnItemId;
              }
            });
            let userSubCategoryValue: number = 0.0;
            qs.matrix.rowdataFields.forEach((r: any, ri: any) => {
              r.cellReferences.forEach((cell: any, cr: any) => {
                if (cell.cellAddress[1] === SubCategoryColumnId && cell.value != '' && cell.value != null) {
                  userSubCategoryValue = userSubCategoryValue + parseFloat(cell.value);
                }
              });
            });
            if (CategoryValue != '' && CategoryValue != null && userSubCategoryValue != parseFloat(CategoryValue)) {
              isContinueToSave = false; qs.isAnswered = false;
            }
          }

        }

        else if (qs.type == "MultipleChoice" && qs.isRequired) {
          if (qs.value == '' || qs.value == null) { isContinueToSave = false; qs.isAnswered = false; }
          else if (qs.value != '') {
            let tempOption: SurveyEntity.Option[];
            tempOption = (qs.multipleChoice as SurveyEntity.Option[])
              .filter(wh => wh.showAdditionalTextBox === true);
            tempOption.forEach((o, oi) => { if (o.additionalTextBoxValue == '' || o.additionalTextBoxValue == null) { isContinueToSave = false; } });
          }
        }
        else if (qs.type == "MultipleResponse" && qs.isRequired) {
          if (qs.value == '' || qs.value == null) { isContinueToSave = false; qs.isAnswered = false; }
          else if (qs.value != '') {
            let tempOption: SurveyEntity.Option[];
            tempOption = (qs.multipleResponse as SurveyEntity.Option[])
              .filter(wh => wh.showAdditionalTextBox === true);
            tempOption.forEach((o, oi) => { if (o.additionalTextBoxValue == '' || o.additionalTextBoxValue == null) { isContinueToSave = false; } });
          }
        }
        else if ((qs.type == "Slider" || qs.type == "RankingSort" || qs.type == "Description" || qs.type == "TextInput" || qs.type == "Picklist") && qs.isRequired) {
          if (qs.value == '') { isContinueToSave = false; qs.isAnswered = false; }
        }
        else {
          if (isContinueToSave !== false) {
            isContinueToSave = true;
          }

        }
      }

    });



    return isContinueToSave;
  }
  plainLayoutsubmitSurvey(form: any) {
    this.requiredValidationTriggered = true;
    setTimeout(() => {
      let currentSection: SurveyEntity.Section[];
      currentSection = (form.value.sections as SurveyEntity.Section[])
        .filter(wh => wh.type === 'Questionnaire' && wh.id === this.activeTabId)
        .sort((a, b) => a.qSOrder - b.qSOrder);

      if (currentSection.length > 0) {
        var isContinueToSave = this.ValidateRowLevelMandatory(currentSection[0]);
        if (!isContinueToSave) {
          //this.toasterService.clear();
          //this.toasterService.error(this.key_Next_Validation_Message);
          return;
        }
      }

      $(document).find('.bReq').removeClass('bReq');
      if ($(document).find('.bReq').length == 0) {
        //console.log('success');
        let data = JSON.stringify(form.value);
        this.http.post(this.myAppUrl + this._SurveySubmitSurveyUrl, data, this.httpOptions).subscribe(result => {
          if (result == "true") {

            this.isJustSubmitted = true;
          }
        });
      }
      else {
        //this.toasterService.clear();
        //this.toasterService.error(this.key_Next_Validation_Message);
      }
    }, 1000);
  }

  onSave(form: FormGroup) {
    $(document).find('.bReq').removeClass('bReq');
    if ($(document).find('.bRed').length == 0) {
      this.saveClicked = true;
      let data = JSON.stringify(form.value);
      debugger
      this.http.post(this.myAppUrl + this._SurveySaveResponseUrl, data, this.httpOptions).subscribe(result => {
        // If result is a string, compare directly
        if (result === "true" || (typeof result === "object" && result === "true")) {
          this.successOrFailureMessage = "Survey responses have been saved successfully.";
          window.setTimeout(() => {
            this.successOrFailureMessage = '';
          }, 1200);
        } else {
          this.successOrFailureMessage = "Error occurred while saving survey responses. Please contact administrator.";
          window.setTimeout(() => {
            this.successOrFailureMessage = '';
          }, 1200);
        }
      });
    }
    else {
      //this.toasterService.clear();
      //this.toasterService.error("Please resolve all validation errors before save or submit", "Errors in Page");
    }
  }
  updateSurveyStatus(form: any) {
    let data = JSON.stringify(form.value);
    const httpOptionsNew = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      }),
      params: {
        JustExitedQuestionId: this.isJustExitedQuestionId.toString(),
        userId: form.value.userId,
        serviceLineId: form.value.serviceLineId,
        companyId: form.value.companyId,
        surveyId: form.value.surveyId,
        JustExitedsectionId: this.JustExitedsectionId.toString(),

      }
    };
    this.http.post(this.myAppUrl + this._updateSurveyStatusUrl, '', httpOptionsNew).subscribe(result => {
      if (result == true) {
        location.reload();

      }
    }, error => { alert(error.message) });
  }
  onRadioButtonChange($event: any, row: SurveyEntity.RowdataField, column: SurveyEntity.ColumnField) {
    let thisRow = row.cellReferences.find(n => n.cellAddress.length > 0 && n.cellAddress[0] == row.rowItemId && n.cellAddress[1] == column.columnItemId);
    row.cellReferences.forEach((c, ci) => {
      let tempRow = row.cellReferences.find(n => n.cellAddress.length > 0 && n.cellAddress[0] == row.rowItemId && n.cellAddress[1] == c.cellAddress[1]);
      if (tempRow) {
        tempRow.value = null;
      }
    });
    //thisRow.value = $event.target.checked?"Yes":"No";
    if (thisRow) {
      thisRow.value = $event.target.checked;
    }
    this.markAsFormChange();
    this.updateProgressBar();
  }


  onMatrixRadioButtonChange($event: any, row: SurveyEntity.RowdataField, column: SurveyEntity.ColumnField, question: SurveyEntity.Question) {
    var questionRowItemId = row.rowItemId;
    var questionColumnItemId = column.columnItemId;
    var questionId = question.qid;
    var sections = this.surveyForm.value.sections;

    let thisRow = row.cellReferences.find(n => n.cellAddress.length > 0 && n.cellAddress[0] == row.rowItemId && n.cellAddress[1] == column.columnItemId);
    row.cellReferences.forEach((c: any, ci: any) => {
      let tempRow = row.cellReferences.find(n => n.cellAddress.length > 0 && n.cellAddress[0] == row.rowItemId && n.cellAddress[1] == c.cellAddress[1]);
      if (tempRow) {
        tempRow.value = null;

      }
    });
    if (thisRow) {
      thisRow.value = $event.target.checked;
    }

    if (this.MatrixQuestionConditionalSettings !== null && this.MatrixQuestionConditionalSettings.length >= 1) {
      this.setMatrixConditionalSetting(row, column, question);
    }

    this.markAsFormChange();
    this.updateProgressBar();
  }

  onCheckBoxChange($event: any, row: SurveyEntity.RowdataField, column: SurveyEntity.ColumnField) {
    let thisRow = row.cellReferences.find(n => n.cellAddress.length > 0 && n.cellAddress[0] == row.rowItemId && n.cellAddress[1] == column.columnItemId);
    //thisRow.value = $event.target.checked?"Yes":"No";
    if (thisRow) {
      thisRow.value = $event.target.checked;
    }
    this.markAsFormChange();
    this.updateProgressBar();
  }
  onCellChange($event: any, row: SurveyEntity.RowdataField, column: SurveyEntity.ColumnField) {
    let dsValue: string = "";
    let cntrlValue: any;
    let _typeCheck: boolean;
    let errorMessage: string = "";
    switch (column.columnType.toLowerCase()) {
      case "decimal":
        cntrlValue = Number($event.target.value);
        _typeCheck = Number.isFinite(cntrlValue);
        if (!_typeCheck) {
          errorMessage = "Please enter decimal values only";
        }
        break;
      case "percentage":
        cntrlValue = Number($event.target.value);
        _typeCheck = Number.isFinite(cntrlValue) && cntrlValue >= 0 && cntrlValue <= 100;
        if (!_typeCheck) {
          errorMessage = "Please enter values in percentage only";
        }
        break;
      case "integer":
        cntrlValue = Number($event.target.value);
        _typeCheck = Number.isInteger(Number($event.target.value));
        if (!_typeCheck) {
          errorMessage = "Please enter non-decimal numbers only";
        }
        break;
      default:
        _typeCheck = true;
        break;
    }
    if (!_typeCheck) {
      $($event.target).addClass('bRed');
      //this.toasterService.clear();
      //this.toasterService.error(errorMessage, column.columnHeaderText);
      return;
    }
    else {
      $($event.target).removeClass('bRed');
    }
    let thisRow = row.cellReferences.find(n => n.cellAddress.length > 0 && n.cellAddress[0] == row.rowItemId && n.cellAddress[1] == column.columnItemId);
    if (column.dataSource != null && column.dataSource.length > 0) {
      dsValue = column.dataSource.find(n => n.text.trim() == $event.target.value.trim()).value;
    }
    else {
      dsValue = $event.target.value;
    }
    if (thisRow) {
      thisRow.value = dsValue;
    }
    this.markAsFormChange();
    this.updateProgressBar();
  }
  onTexBoxChange(event: any, option: SurveyEntity.Option, question: any) {

    option.additionalTextBoxValue = event.target.value;
    this.markAsFormChange();
    this.updateProgressBar();
  }
  onRadioChange(event: any, option: SurveyEntity.Option, question: any, surveyForm: any, section: any) {

    if (event.target.checked) {

      let tempOption: SurveyEntity.Option[];
      tempOption = (question.value.multipleResponse as SurveyEntity.Option[]); tempOption.forEach((o, oi) => { if (o.showAdditionalTextBox == true) { o.showAdditionalTextBox = false; } });
      tempOption.forEach((o, oi) => { if (o.additionalTextBoxValue != null) { o.additionalTextBoxValue = ''; } });
      let showSetting = (this.AdaptiveSettings as SurveyEntity.AdaptiveAssessmentSettings[])
        .filter(n => n.questionId === question.value.qid && n.sectionId === section.value.id && n.isShow === true);
      showSetting.forEach((o: any, oi: any) => {
        if (option.optionId == o.optionId) {
          o.isShow = true;
        }
      });
      let hideSetting = (this.AdaptiveSettings as SurveyEntity.AdaptiveAssessmentSettings[])
        .filter(n => n.questionId === question.value.qid && n.sectionId === section.value.id && n.isShow === false);
      hideSetting.forEach((o: any, oi: any) => {
        if (option.optionId == o.optionId) {
          o.isShow = false;
        }
      });

      if (this.MatrixQuestionConditionalSettings !== null && this.MatrixQuestionConditionalSettings.length >= 1) {
        this.setMatrixConditionalSetting(option, question, section);
      }

      if (this.OptionAndSectionList != null && this.OptionAndSectionList.length > 0) {
        if (question.value.type.toLowerCase() == 'multipleresponse') {
          this.setOptionAndSectionSettingForMC(surveyForm, question, section, question.value.value)
        }
        else {
          this.setOptionAndSectionSetting(question.value.value, surveyForm, question, section)
        }
      }
      if (this.MergeCodeSettings != null && this.MergeCodeSettings.length > 0) {
        this.setMergeCodeSetting(option.value, surveyForm, question, section);
      }
      if (this.DependentOptionList != null && this.DependentOptionList.length > 0) {
        this.setDependentOptionSetting(option.optionId, surveyForm, question, section);
      }
    }

    this.markAsFormChange();
    this.updateProgressBar();
    if (event.target.checked && option.evaluateAndExit) {
      this.isJustExitedQuestionId = question.value.qid;
      this.JustExitedsectionId = this.activeTabId;
      this.updateActiveSection();

    }
    else if (event.target.checked && option.isTextBoxRequired) {
      option.showAdditionalTextBox = true;
    }

  }
  markAsFormChange() {
    if (!this.surveyForm.controls.flagChanges.touched) {
      this.surveyForm.controls.flagChanges.markAsTouched();
    }
  }
  setOptionAndSectionSetting(optionId: any, surveyForm: any, question: any, section: any) {

    let currentOptionAndSectionSetting: SurveyEntity.OptionAndSectionSettings[];
    currentOptionAndSectionSetting = this.OptionAndSectionList.filter(
      n => n.questionId == question.value.qid &&
        n.sectionId == section.value.id &&
        n.optionId == optionId
    );
    if (currentOptionAndSectionSetting.length > 0) {
      var section = surveyForm.value.sections;
      var tmpIsPBar = false;
      section.forEach((q: any, i: any) => {

        let updateSection: SurveyEntity.OptionAndSectionSettings[];
        updateSection = currentOptionAndSectionSetting.filter(
          n => n.actionBySectionId == q.id && n.isHide === true
        );
        if (updateSection.length >= 1) {
          q.isHide = true;
        }
        updateSection = currentOptionAndSectionSetting.filter(
          n => n.actionBySectionId == q.id && n.isHide === false
        );
        if (updateSection.length >= 1) {
          q.isHide = false;
        }

      });
      this.totalQuestionCount = 0;
      this.attemptedQuestionCount = 0;
      this.attemptedPercentage = 0;
      if (this.surveyData.isprogressbar) {
        this.totalQuestionCount = 0;
        surveyForm.value.sections.forEach((qp: any, i: any) => {
          if (qp.isHide != true) {
            this.totalQuestionCount = this.totalQuestionCount + qp.questions.length;
            qp.questions.forEach((qs: any, qsi: any) => {
              this.setProgressBarAttemptedQuesCount(qs);
            });

          }

        });
        this.attemptedPercentage = Math.round((this.attemptedQuestionCount / this.totalQuestionCount) * 100);
      }

      var tabs = this.surveyData.metaBody.sections;
      var nextTabOrder = this.tabIndex + 1;
      var nextTabObject = tabs[nextTabOrder];
      if (nextTabObject.type === "Questionnaire") {

        var isLastTab: number = this.tabIndex + 1;
        var isLast: boolean = false;

        let lastIndex = isLastTab;
        let isActiveLastTab = false;

        while (!isLast && isLastTab < this.surveyData.metaBody.sections.length) {

          let currentSectionId = this.surveyData.metaBody.sections[isLastTab].id;

          let formcurrentSection: SurveyEntity.Section[];
          formcurrentSection = (surveyForm.value.sections as SurveyEntity.Section[])
            .filter(wh => wh.type == 'Questionnaire' && wh.id == currentSectionId)
            .sort((a, b) => a.qSOrder - b.qSOrder);

          if (formcurrentSection[0].isHide != null && formcurrentSection[0].isHide == true && this.surveyData.metaBody.sections.length - 1 === isLastTab) {

            isLast = false;
            lastIndex = isLastTab;
            isActiveLastTab = true;
          }
          else if (formcurrentSection[0].isHide == true) {
            isLast = false;
          }
          else {
            isLast = true;

          }
          isLastTab = isLastTab + 1;
        }
        if (isActiveLastTab == true) {
          this.lastTab = true;
        }
        else {
          this.lastTab = false;
        }
      }
    }

  }
  setOptionAndSectionSettingForMC(surveyForm: any, question: any, currentSection: any, selectedOptions: any) {

    var section = this.surveyForm.value.sections;
    this.surveyForm.patchValue({
      sections: section
    });
    if (question.value.type.toLowerCase() == 'multiplechoice' || question.value.type.toLowerCase() == 'multipleresponse') {

      let showSectionList: number[] = [];
      let hideSectionList: number[] = [];
      let selectedOptionList: number[] = [];

      selectedOptionList = question.value.value.split(',');


      let showSetting = this.OptionAndSectionList.filter(
        n => n.questionId == question.value.qid &&
          n.sectionId == currentSection.value.id &&
          n.isHide === false
      );
      showSetting.forEach((o: any, oi: any) => {
        if (selectedOptionList.findIndex(x => x == o.optionId) >= 0 && showSectionList.findIndex(x => x === o.actionBySectionId) <= -1) {
          showSectionList.push(o.actionBySectionId);
        }
      });


      let hideSetting = this.OptionAndSectionList.filter(
        n => n.questionId == question.value.qid &&
          n.sectionId == currentSection.value.id &&
          n.isHide === true
      );
      hideSetting.forEach((o: any, oi: any) => {
        if (showSectionList.findIndex(x => x == o.actionBySectionId) <= -1 && hideSectionList.findIndex(x => x === o.actionBySectionId) <= -1) {
          hideSectionList.push(o.actionBySectionId);
        }
      });

      var questionSection = surveyForm.value.sections;
      questionSection.forEach((q: any, i: any) => {
        if (showSectionList.findIndex(x => x === q.id) > -1) {
          q.isHide = false;
        }
        if (hideSectionList.findIndex(x => x === q.id) > -1) {
          q.isHide = true;
        }
      });

      this.totalQuestionCount = 0;
      this.attemptedQuestionCount = 0;
      this.attemptedPercentage = 0;
      if (this.surveyData.isprogressbar) {
        this.totalQuestionCount = 0;
        surveyForm.value.sections.forEach((qp: any, i: any) => {
          if (qp.isHide != true) {
            this.totalQuestionCount = this.totalQuestionCount + qp.questions.length;
            qp.questions.forEach((qs: any, qsi: any) => {
              this.setProgressBarAttemptedQuesCount(qs);
            });

          }

        });
        this.attemptedPercentage = Math.round((this.attemptedQuestionCount / this.totalQuestionCount) * 100);
      }

      var tabs = this.surveyData.metaBody.sections;
      var nextTabOrder = this.tabIndex + 1;
      var nextTabObject = tabs[nextTabOrder];

      if (typeof nextTabObject !== 'undefined' && nextTabObject !== null) {
        if (nextTabObject.type === "Questionnaire") {

          var isLastTab: number = this.tabIndex + 1;
          var isLast: boolean = false;

          let lastIndex = isLastTab;
          let isActiveLastTab = false;

          while (!isLast && isLastTab < this.surveyData.metaBody.sections.length) {

            let currentSectionId = this.surveyData.metaBody.sections[isLastTab].id;

            let formcurrentSection: SurveyEntity.Section[];
            formcurrentSection = (surveyForm.value.sections as SurveyEntity.Section[])
              .filter(wh => wh.type == 'Questionnaire' && wh.id == currentSectionId)
              .sort((a, b) => a.qSOrder - b.qSOrder);

            if (formcurrentSection[0].isHide != null && formcurrentSection[0].isHide == true && this.surveyData.metaBody.sections.length - 1 === isLastTab) {

              isLast = false;
              lastIndex = isLastTab;
              isActiveLastTab = true;
            }
            else if (formcurrentSection[0].isHide == true) {
              isLast = false;
            }
            else {
              isLast = true;

            }
            isLastTab = isLastTab + 1;
          }
          if (isActiveLastTab == true) {
            this.lastTab = true;
          }
          else {
            this.lastTab = false;
          }
        }
      }
    }
  }
  setMergeCodeSetting(optionName: any, surveyForm: any, question: any, section: any) {
    let currentMergeCodeSetting: SurveyEntity.MergeCodeSettings[];
    currentMergeCodeSetting = this.MergeCodeSettings.filter(
      n => n.questionId == question.value.qid && n.sectionId == section.value.id
    );

    let optionSelected: string = '';
    //Get the name of the option that was selected by the user
    if (question.value.type.toLowerCase() === 'picklist') {
      question.value.pickList.forEach((pl: any, i: any) => {
        if (pl.value === optionName) {
          optionSelected = pl.text;
        }
      });
    }

    if (question.value.type.toLowerCase() === 'multipleresponse') {
      question.value.multipleResponse.forEach((pl: any, i: any) => {
        if (pl.value === optionName) {
          optionSelected = pl.value;
        }
      });
    }

    if (currentMergeCodeSetting.length > 0) {
      var section = surveyForm.value.sections;
      section.forEach((q: any, i: any) => {
        var choiceQuestionList = q.questions.filter(
          (q: SurveyEntity.Question) =>
            q.type.toLowerCase() === "picklist" ||
            q.type.toLowerCase() === "multipleresponse"
        );
        choiceQuestionList.forEach((c: any, ci: any) => {
          if (c.value != null || c.value != "") {
            let updateQuestion: SurveyEntity.MergeCodeSettings[];
            updateQuestion = currentMergeCodeSetting.filter(
              n => n.sectionId == q.id && n.questionId == c.qid /*&& n.optionId == Number(c.value)*/
            );
            updateQuestion.forEach((u: any, ui: any) => {
              section.forEach((uq: any, uqi: any) => {
                let Question: SurveyEntity.Question[];
                if (u.actionBySectionId == uq.id) {
                  Question = uq.questions.filter((n: SurveyEntity.Question) => n.qid == u.actionByQuestionId); if (Question != null && Question.length >= 1) {
                    //Question[0].text = Question[0].originalText.split(u.mergeText).join(optionSelected);
                    if (u.questionOption == optionSelected) {
                      if (u.actionByQuestionOptionId > 0) {
                        if (Question[0].type.toLowerCase() === 'picklist') {
                          Question[0].pickList.forEach((pl, i) => {
                            if (u.actionByQuestionOption == pl.text && pl.text.indexOf(u.mergeText) !== -1) {
                              pl.text = pl.text.split(u.mergeText).join(optionSelected);
                              //pl.value = pl.value.split(u.mergeText).join(optionSelected);
                            }
                          });
                        }

                        if (Question[0].type.toLowerCase() === 'multipleresponse') {
                          Question[0].multipleResponse.forEach((mr, i) => {
                            if (u.actionByQuestionOption == mr.value && mr.value.indexOf(u.mergeText) !== -1) {
                              mr.name = mr.name.split(u.mergeText).join(optionSelected);
                              mr.value = mr.value.split(u.mergeText).join(optionSelected);
                              mr.hoverText = mr.hoverText.split(u.mergeText).join(optionSelected);
                            }
                          });
                        }
                      }
                      else {
                        Question[0].text = Question[0].originalText.split(u.mergeText).join(optionSelected);
                      }
                    }

                    //if (this.latestMergeTextUI !== "" || this.latestMergeTextUI !== null) {
                    //  Question[0].text = Question[0].originalText.split(this.latestMergeTextUI).join(optionSelected);
                    //}
                    //else {
                    //  Question[0].text = Question[0].originalText.split(u.mergeText).join(optionSelected);
                    //}


                  }
                }
              });
            });
          }
        });
      });

      this.surveyForm.patchValue({
        sections: section
      });
    }

    this.latestMergeTextUI = optionSelected;
  }
  updateActiveSection() {
    if (!this.surveyForm.value.isPreview) {
      this.formchanged = false;
      let prevTabId = Number($('[formarrayname="sections"]')?.find('a.active')?.attr('id')?.split('-')[0]);
      let data: SurveyEntity.MetaForm = {
        responseId: Number(this.surveyForm.value.responseId),
        serviceLineId: Number(this.surveyForm.value.serviceLineId),
        companyId: Number(this.surveyForm.value.companyId),
        userId: Number(this.EncrDecr.get(localStorage.getItem('userId') ?? "-1")),
        surveyId: Number(this.surveyForm.value.surveyId),
        surveytitle: this.surveyForm.value.surveytitle,
        surveydescription: "",
        surveytype: this.surveyForm.value.surveytype,
        isautosave: this.surveyForm.value.isautosave == true,
        isprogressbar: this.surveyForm.value.isprogressbar,
        perpage: Number(this.surveyForm.value.perpage),
        isPreview: this.isPreview,
        sections: this.surveyForm.value.sections.filter((n: SurveyEntity.Section) => n.id == prevTabId), isforcefullysubmitted: true
      }
      debugger
      this.http.post(this.myAppUrl + this._SurveySaveResponseUrl, JSON.stringify({ meta: data }), this.httpOptions).subscribe(result => {

        //this.http.post(this.myAppUrl + this._SurveySaveResponseUrl, JSON.stringify(data), this.httpOptions).subscribe(result => {
        this.surveyForm.controls.flagChanges.markAsUntouched();
        this.isJustExited = true;

      });


    }
  }
  setMatrixConditionalSetting(row: any, column: SurveyEntity.ColumnField, question: SurveyEntity.Question) {
    let currentMatrixConditionalSettings: MatrixQuestionConditionalSetting[];
    currentMatrixConditionalSettings = (this.MatrixQuestionConditionalSettings as MatrixQuestionConditionalSetting[])
      .filter(x =>
        x.questionId === question.qid &&
        x.questionRowItemId === row.rowItemId &&
        x.questionColumnItemId === column.columnItemId
      );
    let sections = this.surveyForm.value.sections;
    sections.forEach((s: any, si: any) => {
      s.questions.forEach((q: any, qi: any) => {
        let updateQuestionForSetting: MatrixQuestionConditionalSetting[];
        updateQuestionForSetting = (currentMatrixConditionalSettings as MatrixQuestionConditionalSetting[])
          .filter(x => x.actionByQuestionId === q.qid && x.actionBySectionId === s.id && x.isShow === false);
        if (updateQuestionForSetting.length >= 1) {
          q.isShow = false;
        }

        updateQuestionForSetting = (currentMatrixConditionalSettings as MatrixQuestionConditionalSetting[])
          .filter(x => x.actionByQuestionId === q.qid && x.actionBySectionId === s.id && x.isShow === true);
        if (updateQuestionForSetting.length >= 1) {
          q.isShow = true;
        }
      });
    });

    this.surveyForm.patchValue({
      sections: sections
    });

  }
  setDependentOptionSetting(optionId: any, surveyForm1: any, question: any, section: any) {
    let currentAdaptiveSetting: SurveyEntity.DependentQuestionOptionSettings[];
    currentAdaptiveSetting = this.DependentOptionList.filter(
      n => n.questionId == question.value.qid && n.sectionId == section.value.id && n.optionId == optionId
    );
    if (currentAdaptiveSetting.length > 0) {
      var section1 = surveyForm1.value.sections;
      var section = this.surveyForm.value.sections;
      var tmpIsPBar = false;
      section.forEach((q: any, i: any) => {
        q.questions.forEach((qs: any, qsi: any) => {
          this.pickListItemList = [];
          let updateQuestion: SurveyEntity.DependentQuestionOptionSettings[];
          updateQuestion = currentAdaptiveSetting.filter(
            n => n.actionByQuestionId == qs.qid && n.actionBySectionId == q.id
          );
          if ((qs.type == "Picklist") && updateQuestion.length >= 1) {
            qs.pickList.forEach((o: any, oi: any) => {
              let options = updateQuestion.filter(x => x.actionByOptionId == o.value);
              if (options != null && options.length >= 1) {
                o.display = true;
              }
              else {
                o.display = false;

              }
            });
            this.filledDependentOption = true;

          }

          if ((qs.type.toLowerCase() == "multipleresponse") && updateQuestion.length >= 1) {
            qs.multipleResponse.forEach((o: any, oi: any) => {
              let options = updateQuestion.filter(x => x.actionByOptionId == o.optionId);
              if (options != null && options.length >= 1) {
                o.display = true;
              }
              else {
                o.display = false;

              }
            });
            this.filledDependentOption = true;

          }

        });
      });
    }

  }
  setAdaptiveSetting(optionId: any, surveyForm: any, question: any, section: any) {


    let currentAdaptiveSetting: SurveyEntity.AdaptiveAssessmentSettings[];
    currentAdaptiveSetting = (this.AdaptiveSettings as SurveyEntity.AdaptiveAssessmentSettings[])
      .filter(n =>
        n.questionId === question.value.qid &&
        n.sectionId === section.value.id &&
        n.optionId === optionId
      );
    var section = surveyForm.value.sections;
    section.forEach((q: any, i: any) => {
      q.questions.forEach((qs: any, qsi: any) => {

        let updateQuestion: SurveyEntity.AdaptiveAssessmentSettings[];
        updateQuestion = (currentAdaptiveSetting as SurveyEntity.AdaptiveAssessmentSettings[])
          .filter(n =>
            n.actionByQuestionId === qs.qid &&
            n.actionBySectionId === q.id &&
            n.isShow === false
          );
        if (updateQuestion.length >= 1) {
          qs.isShow = false;
        }
        updateQuestion = (currentAdaptiveSetting as SurveyEntity.AdaptiveAssessmentSettings[])
          .filter(n =>
            n.actionByQuestionId === qs.qid &&
            n.actionBySectionId === q.id &&
            n.isShow === true
          );
        if (updateQuestion.length >= 1) {
          qs.isShow = true;
        }
      });
    });

    this.surveyForm.patchValue({
      sections: section
    })
  }

  setAdaptiveSettingForMC(surveyForm: any, question: any, currentSection: any, selectedOptions: any) {
    var section = this.surveyForm.value.sections;
    //this.surveyForm.patchValue({
    //  sections: section
    //});
    if (question.value.type.toLowerCase() == 'multiplechoice' || question.value.type.toLowerCase() == 'multipleresponse') {

      let showQuestionList: string[] = [];
      let hideQuestionList: string[] = [];
      let selectedOptionList: string[] = [];

      selectedOptionList = question.value.value.split(',');


      const showSetting = (this.AdaptiveSettings || []).filter(
        n => n.questionId === question.value.qid &&
          n.sectionId === currentSection.value.id &&
          n.isShow === true
      );
      showSetting.forEach((o, oi) => {
        let tempSectionId: string = o.actionBySectionId.toString();
        let tempQuestionId: string = o.actionByQuestionId.toString();
        if (selectedOptionList.findIndex(x => x == o.optionId.toString()) >= 0 && showQuestionList.findIndex(x => x == tempSectionId + ',' + tempQuestionId) <= -1) {
          showQuestionList.push(tempSectionId + ',' + tempQuestionId);
        }
      });


      const hideSetting = (this.AdaptiveSettings || []).filter(
        n => n.questionId === question.value.qid &&
          n.sectionId === currentSection.value.id &&
          n.isShow === false
      );
      hideSetting.forEach((o, oi) => {
        let tempSectionId: string = o.actionBySectionId.toString();
        let tempQuestionId: string = o.actionByQuestionId.toString();
        if (showQuestionList.findIndex(x => x === (tempSectionId + ',' + tempQuestionId)) <= -1 && hideQuestionList.findIndex(x => x === (tempSectionId + ',' + tempQuestionId)) <= -1) {
          hideQuestionList.push(tempSectionId + ',' + tempQuestionId);
        }
      });

      var questionSection = surveyForm.value.sections;
      questionSection.forEach((s: any, i: any) => {
        s.questions.forEach((qs: any, qsi: any) => {
          let tempSectionId: string = s.id.toString();
          let tempQuestionId: string = qs.qid.toString();
          if (showQuestionList.findIndex(x => x === (tempSectionId + ',' + tempQuestionId)) > -1) {
            qs.isShow = true;
          }
          if (hideQuestionList.findIndex(x => x === (tempSectionId + ',' + tempQuestionId)) > -1) {
            qs.isShow = false;
          }
        });
      });


    }
  }
  fetchSurveyLanguages() {
    this.surveyService.getSurveyLanguages()
      .toPromise().then(data => {
        this._languageList = data;
      });
  }
  loadSurvey() {

    let userId = this.EncrDecr.get(localStorage.getItem('userId') ?? "");
    this.userId = userId;
    var survD = this.surveyData;
    this.docForm = new FormGroup({
      documentname: new FormControl(null),
      file: new FormControl(null, Validators.required)
    });
    this.sectionDocs = new FormGroup({
      documentname: new FormControl(null),
      file: new FormControl(null, Validators.required)
    });
    this.selectedSection.Name = 'Default Section';
    this.sectionForm = new FormGroup({
      documentname: new FormControl(null, Validators.required),
      sectionConfirmation: new FormControl('AT')
    });

    this.surveyService.getSurveyProviderLanguageMappedDetails(this.surveyId, this.serviceLineId, this.companyId).toPromise().then(data => {
      this.surveyProviderLanguageMappedDetails = data;
      //var surveyLanguageMappedDetails = this.surveyProviderLanguageMappedDetails;
      this.getAllSectionConfiguration(this.surveyId.toString());
      this.getUIConfiguration(this.surveyId.toString());
    });

    this.surveyService.getSurveySchema(this.surveyId, this.serviceLineId, this.isPreview, this.companyId)
      .subscribe(data => {
        this.surveyData = data;
        this.showQuestionNumber = data.showQuestionNumber;
        this.showQuestionPrefix = data.showQuestionPrefix;

        if (this.ssUserId === '-1') {
          this.surveyData.userId = parseInt(this.ssUserId);
        }
        if (this.ssUserId === '-2') {
          this.surveyData.userId = parseInt(this.ssUserId);
        }

        let qSectionExists: boolean = false;

        this.surveyData.metaBody.sections = this.surveyData.metaBody.sections
          .slice() // optional: to avoid mutating the original array
          .sort((a, b) => a.order - b.order);
        this.surveyData.metaBody.sections.forEach((s, i) => {
          if (s.type != 'Questionnaire') {
            if (s.isConfirmationRequires && (!s.isConfirmed)) {
              this.isAllSectionConfirmed = false;

            }
            this.dSections.push(s);
          }
          if (s.type == 'Questionnaire' && qSectionExists == false) {
            this.dSections.push(s);
            qSectionExists = true;
          }

        });
        this.qSections = this.surveyData.metaBody.sections
          .filter(wh => wh.type === 'Questionnaire')
          .sort((a, b) => a.qSOrder - b.qSOrder);
        this.iSections = this.surveyData.metaBody.sections
          .filter(wh => wh.type === 'Informational')
          .sort((a, b) => a.order - b.order);
        this.qSections.forEach((q, i) => {
          this.totalQuestionCount = this.totalQuestionCount + q.questions.length;
          q.questions.forEach((qs, qsi) => {
            if (this.surveyData.isprogressbar) {
              this.setProgressBarAttemptedQuesCount(qs);
            }

            if (qs.type.toLowerCase() === "slider") {
            }
            if (qs.type.toLowerCase() === "rankingsort" && qs.value != '') {
              this.setRankingSortOrder(qs);
            }
            qs.matrix.rowdataFields.forEach((r, ri) => {
              qs.matrix.columnFields.forEach((c, ci) => {
                const cell: SurveyEntity.CellReference = {
                  cellAddress: [r.rowItemId, c.columnItemId],
                  value: '',
                  smqid: 0
                };
                var IsCellEx = r.cellReferences.some(
                  n => n.cellAddress.length > 0 && n.cellAddress[0] === r.rowItemId && n.cellAddress[1] === c.columnItemId
                );
                if (!IsCellEx) {
                  r.cellReferences.push(cell);
                }
              });
            });
          })
        });
        if (this.surveyData.isprogressbar) {
          this.attemptedPercentage = Math.round((this.attemptedQuestionCount / this.totalQuestionCount) * 100);
        }
        try {
          this.surveyData.metaBody.uploadedDocumentsList = this.surveyData.metaBody.uploadedDocumentsList.slice();
        }
        catch (e) {
          alert(e);
        }
        if (this.isPreview && localStorage.getItem('fromModule') != null) {
          this.surveyData.fromModule = localStorage.getItem('fromModule') ?? "";

        }
        else {
          localStorage.setItem('fromModule', "Provider");
          this.surveyData.fromModule = "Provider";
        }

        this.surveyForm = this.formBuilder.group({
          responseId: new FormControl(this.surveyData.responseId),
          serviceLineId: new FormControl(this.serviceLineId),//this.surveyData.serviceLineId
          companyId: new FormControl(this.companyId),//this.surveyData.companyId
          userId: new FormControl(this.EncrDecr.get(localStorage.getItem('userId') ?? "")),//this.surveyData.userId
          surveyId: new FormControl(this.surveyData.surveyId),//this.surveyData.surveyId
          surveytitle: new FormControl(this.surveyData.surveytitle),
          surveydesctiption: new FormControl(""),
          surveytype: new FormControl(this.surveyData.surveytype),
          isautosave: new FormControl(this.surveyData.isautosave),
          isprogressbar: new FormControl(this.surveyData.isprogressbar),
          perpage: new FormControl(this.surveyData.perpage),
          sections: this.initSection(this.qSections),
          flagChanges: this.formDirty,
          isPreview: this.isPreview,
        });
        this.usersurveysettings = this.formBuilder.group({
          surveyLanguage: new FormControl(""),
          preferredLanguageId: new FormControl('')
        });
        this.showQuestionNumber = data.showQuestionNumber;
        this.showQuestionPrefix = data.showQuestionPrefix;
        this.surveyForm.valueChanges.subscribe(value => {
          $('.chosenClass').trigger("chosen:updated");

          this.markAsFormChange();
          this.updateProgressBar();
        });

        this.selectedSection.Name = this.qSections[0].name;
        this.selectedSection.Id = this.qSections[0].id;
        var tabs = this.surveyData.metaBody.sections;
        this.activeTabId = tabs[0].id;
        this.surveyService.getCompanyLogo(this.serviceLineId, this.surveyId)
          .subscribe(response => {
            this.companyLogo = response.logo;
            this.workspaceLogo = response.workspaceLogo;
            this.languageCode = response.language;

            //Get Survey Messages

            this.GetSurveyMessageListBasedOnLanguage(this.languageCode);
            this.surveyService.getSurveyMessages(this.serviceLineId, this.surveyId)
              .toPromise().then((data: any) => {

                var saveLaterTranslation = this.key_Survey_SaveForLater;
                if (data[0].key == 'SurveyAfterSubmitMessage') {
                  this.SurveyAfterSubmitMessage = data[0].value;
                  if (this.languageCode == "it") {
                    this.SurveyAfterSubmitMessage = this.key_Survey_SurveyAfterSubmitMessage;
                  }
                }
                if (data[1].key == 'AllReadySubmittedSurveyMessage') {
                  this.AllReadySubmittedSurveyMessage = data[1].value;
                  if (this.languageCode == "it") {
                    this.AllReadySubmittedSurveyMessage = this.key_Survey_AllReadySubmittedSurveyMessage;
                  }
                }
                if (data[2].key == 'ExpiredSurveyMessage') {
                  this.ExpiredSurveyMessage = data[2].value;
                  if (this.languageCode == "it") {
                    this.ExpiredSurveyMessage = this.key_Survey_ExpiredSurveyMessage;
                  }
                }
                if (data[3].key == 'ForcefullyExited') {
                  this.ForcefullyExited = data[3].value;
                }
                if (data[4].key == 'AlreadyForcefullyExited') {
                  this.AlreadyForcefullyExited = data[4].value;
                }
                if (data[5].key == 'ForcefullyExitedBackToSurvey') {
                  this.ForcefullyExitedBackToSurvey = data[5].value;
                }
                if (data[6].key == 'SubmitPopupMessage') {
                  //   this.SubmitPopupMessage = data[6].value;
                  this.SubmitPopupMessage = this.key_Survey_SubmitPopupMessage;
                  if (this.languageCode == "it") {
                    this.SubmitPopupMessage = this.key_Survey_SubmitPopupMessage;
                  }
                }

                /*});*/
              });

            this.fetchSurveyLanguages();

            this.surveyService.getQuestionLanguageSettings()
              .toPromise().then(data => {
                this.questionLanguageSettingsList = data;
                if (this.questionLanguageSettingsList !== null && this.questionLanguageSettingsList.length > 0 && this.surveyProviderLanguageMappedDetails !== null) {
                  //Get translations for all static text
                  var languageCode = this.languageCode;
                  if (languageCode !== '' && languageCode !== null && languageCode != undefined) {
                    this.surveyLanguageCode = languageCode;
                    //this.translate.use(languageCode);
                    this.preferredLanguageSet = true;
                    this.GetSurveyMessageListBasedOnLanguage(this.surveyLanguageCode);

                  }


                  var dSec = this.dSections.filter(x => x.type.toLowerCase() !== 'questionnaire'); dSec.forEach((ds, z) => {
                    var sectLanguageList = this.questionLanguageSettingsList.filter(
                      x =>
                        x.entityTypeText.toLowerCase() === "informational section" &&
                        x.languageId === this.preferredLanguageId &&
                        x.entityId === ds.id
                    );
                    if (sectLanguageList.length > 0) {
                      var languageText = sectLanguageList[0].languageText;
                      ds.description = languageText;
                    }

                  });

                  this.surveyForm.value.sections.forEach((s: any, i: any) => {
                    s.questions.forEach((q: any, i: any) => {
                      var i1 = 0;
                      var questionLanguageList = this.questionLanguageSettingsList.filter(
                        x => x.questionId === q.qid && x.languageId === this.preferredLanguageId
                      );
                      questionLanguageList.forEach((qls: any, i: any) => {

                        var languageText = qls.languageText;

                        if (qls.entityTypeText.toLowerCase() === 'question text') {
                          q.text = languageText;
                          var sForm = this.surveyForm;
                          var sections = this.getSections(this.surveyForm);
                        }
                        if (qls.entityTypeText.toLowerCase() === 'option text') {
                          var option: any;
                          if (q.type.toLowerCase() === 'multipleresponse') {
                            option = (q.multipleResponse as SurveyEntity.Option[]).find(x => x.optionId === qls.entityId);
                            if (option) {
                              option.name = languageText;
                            }
                            option.name = languageText;
                          }
                          if (q.type.toLowerCase() === 'multiplechoice') {
                            if (option) {
                              option.name = languageText;
                            }
                            option.name = languageText;
                          }
                          if (q.type.toLowerCase() === 'picklist') {
                            option = (q.pickList as SurveyEntity.PickListItem[]).find(x => x.value === qls.entityId.toString());
                            option.text = languageText;
                          }
                          if (q.type.toLowerCase() === 'rankingsort') {
                            option = (q.rankingSort as any[]).find(x => x.optionId == qls.entityId); option.name = qls.languageText;
                          }
                          if (q.type.toLowerCase() === 'slider') {
                            option = (q.slider as any[]).find(x => x.rangeId == qls.entityId);
                            option.rangeDescription = qls.languageText;

                          }

                        }
                        if (qls.entityTypeText.toLowerCase() === 'column item text') {

                          var columnItem = (q.matrix.columnFields as any[]).find(x => x.columnItemId == qls.entityId);                        //   q.matrix.columns[i1].childColumns[0] = qls.languageText;

                          //   i1++;
                          //  columnItem.columnHeaderText = qls.languageText;
                        }
                        if (qls.entityTypeText.toLowerCase() === 'row item text') {
                          var rowItem: any;
                          rowItem = (q.matrix.rowdataFields as any[]).find(x => x.rowItemId == qls.entityId); rowItem.rowText = languageText;
                        }
                      });



                      if (q.type.toLowerCase() === 'matrix') {
                        var matrixHeaders = this.getmatrixHeaders(q);
                        q.matrix.headerInnerHTML = matrixHeaders;
                      }

                    });
                  });

                  var section = this.surveyForm.value.sections;

                  //Code logic just for the sliders in survey rendering
                  section.forEach((q: any, i: any) => {
                    q.questions.forEach((qs: any, i: any) => {
                      if (qs.type.toLowerCase() === 'slider') {

                        this.setSliderValue(qs.slider);
                        this.objOptions = {
                          tmpOptions: this.options,
                          questionId: qs.qid,
                          sectionId: q.id
                        };
                        this.optionList.push(this.objOptions);
                      }
                    });
                  });

                  this.surveyForm.patchValue({
                    sections: section
                  });
                }
              });
            this.surveyService.getQuestionMatrixConditionalSettings(this.surveyId)
              .subscribe(data => {
                this.MatrixQuestionConditionalSettings = data;
              });

            this.surveyService.getAdaptiveAssessmentSettings(this.surveyId)
              .subscribe(data => {
                this.AdaptiveSettings = data;
                if (this.AdaptiveSettings != null && this.AdaptiveSettings.length > 1) {
                  //this.showQuestionNumber = false;
                  var section = this.surveyForm.value.sections;
                  section.forEach((sq: any, si: any) => {
                    let updateQuestion: SurveyEntity.AdaptiveAssessmentSettings[];
                    updateQuestion = (this.AdaptiveSettings as SurveyEntity.AdaptiveAssessmentSettings[])
                      .filter(n => n.actionBySectionId == sq.id);
                    updateQuestion.forEach((uq: any, uqi: any) => {
                      let Question: SurveyEntity.Question[];
                      Question = (sq.questions as SurveyEntity.Question[]).filter(n => n.qid == uq.actionByQuestionId);
                      if (Question != null && Question.length >= 1) {
                        Question[0].isShow = false;
                      }
                    });

                  });

                  section.forEach((q: any, i: any) => {

                    var choiceQuestionList = (q.questions as SurveyEntity.Question[]).filter(q =>
                      q.type.toLowerCase() === "picklist" ||
                      q.type.toLowerCase() === "multipleresponse" ||
                      q.type.toLowerCase() === "multiplechoice"
                    );
                    choiceQuestionList.forEach((c: any, ci: any) => {
                      if (c.value != null || c.value != "") {
                        if (c.type.toLowerCase() == 'multiplechoice') {
                          let showQuestionList: string[] = [];
                          let hideQuestionList: string[] = [];
                          let selectedOptionList: number[] = [];



                          selectedOptionList = c.value.split(',').map(function (item: any) {
                            return parseInt(item, 10);
                          });
                          let showSetting = (this.AdaptiveSettings as SurveyEntity.AdaptiveAssessmentSettings[])
                            .filter(n => n.questionId === c.qid && n.sectionId === q.id && n.isShow === true); showSetting.forEach((o: any, oi: any) => {
                              let tempSectionId: string = o.actionBySectionId.toString();
                              let tempQuestionId: string = o.actionByQuestionId.toString();
                              if (selectedOptionList.findIndex(x => x == o.optionId) >= 0 && showQuestionList.findIndex(x => x == tempSectionId + ',' + tempQuestionId) <= -1) {
                                showQuestionList.push(tempSectionId + ',' + tempQuestionId);
                              }
                            });


                          let hideSetting = (this.AdaptiveSettings as SurveyEntity.AdaptiveAssessmentSettings[])
                            .filter(n => n.questionId === c.qid && n.sectionId === q.id && n.isShow === false);
                          hideSetting.forEach((o: any, oi: any) => {
                            let tempSectionId: string = o.actionBySectionId.toString();
                            let tempQuestionId: string = o.actionByQuestionId.toString();
                            if (showQuestionList.findIndex(x => x === (tempSectionId + ',' + tempQuestionId)) <= -1 && hideQuestionList.findIndex(x => x === (tempSectionId + ',' + tempQuestionId)) <= -1) {
                              hideQuestionList.push(tempSectionId + ',' + tempQuestionId);
                            }
                          });

                          var questionSection = this.surveyForm.value.sections;
                          questionSection.forEach((s: any, i: any) => {
                            s.questions.forEach((qs: any, qsi: any) => {
                              let tempSectionId: string = s.id.toString();
                              let tempQuestionId: string = qs.qid.toString();
                              if (showQuestionList.findIndex(x => x === (tempSectionId + ',' + tempQuestionId)) > -1) {
                                qs.isShow = true;
                              }
                              if (hideQuestionList.findIndex(x => x === (tempSectionId + ',' + tempQuestionId)) > -1) {
                                qs.isShow = false;
                              }
                            });
                          });
                        }
                        else {
                          let updateQuestion: SurveyEntity.AdaptiveAssessmentSettings[];
                          updateQuestion = (this.AdaptiveSettings as SurveyEntity.AdaptiveAssessmentSettings[])
                            .filter(n => n.sectionId === q.id && n.questionId === c.qid && n.optionId === Number(c.value));
                          updateQuestion.forEach((u: any, ui: any) => {
                            section.forEach((uq: any, uqi: any) => {
                              if (u.actionBySectionId == uq.id) {
                                uq.isHide = u.isHide;
                              }
                            });

                          });
                        }
                      }
                    });
                  });

                }
              });
            this.surveyService.getOptionAndSectionSettings(this.surveyId)
              .subscribe(data => {
                this.OptionAndSectionList = data;
                if (this.OptionAndSectionList != null && this.OptionAndSectionList.length > 1) {
                  this.totalQuestionCount = 0;
                  this.attemptedQuestionCount = 0;
                  this.attemptedPercentage = 0;
                  var section = this.surveyForm.value.sections;
                  this.totalQuestionCount = 0;
                  section.forEach((q: any, i: any) => {
                    var choiceQuestionList = (q.questions as SurveyEntity.Question[])
                      .filter(q =>
                        q.type.toLowerCase() === "picklist" ||
                        q.type.toLowerCase() === "multipleresponse" ||
                        q.type.toLowerCase() === "multiplechoice"
                      );
                    choiceQuestionList.forEach((c: any, ci: any) => {
                      if (c.value != null || c.value != "") {
                        if (c.type.toLowerCase() == 'multiplechoice') {
                          let showSectionList: number[] = [];
                          let hideSectionList: number[] = [];
                          let selectedOptionList: number[] = [];

                          selectedOptionList = c.value.split(',').map(function (item: any) {
                            return parseInt(item, 10);
                          });

                          let showSetting = (this.OptionAndSectionList as SurveyEntity.OptionAndSectionSettings[])
                            .filter(n => n.questionId === c.qid && n.sectionId === q.id && n.isHide === false);
                          showSetting.forEach((o: any, oi: any) => {
                            if (selectedOptionList.findIndex(x => x == o.optionId) >= 0 && showSectionList.findIndex(x => x === o.actionBySectionId) <= -1) {
                              showSectionList.push(o.actionBySectionId);
                            }
                          });


                          let hideSetting = (this.OptionAndSectionList as SurveyEntity.OptionAndSectionSettings[])
                            .filter(n => n.questionId === c.qid && n.sectionId === q.id && n.isHide === true);
                          hideSetting.forEach((o, oi) => {
                            if (showSectionList.findIndex(x => x == o.actionBySectionId) <= -1 && hideSectionList.findIndex(x => x === o.actionBySectionId) <= -1) {
                              hideSectionList.push(o.actionBySectionId);
                            }
                          });

                          var questionSection = this.surveyForm.value.sections;
                          questionSection.forEach((q: any, i: any) => {
                            if (showSectionList.findIndex(x => x === q.id) > -1) {
                              q.isHide = false;
                            }
                            if (hideSectionList.findIndex(x => x === q.id) > -1) {
                              q.isHide = true;
                            }
                          });
                        }
                        else {
                          let updateQuestion: SurveyEntity.OptionAndSectionSettings[];
                          updateQuestion = (this.OptionAndSectionList as SurveyEntity.OptionAndSectionSettings[])
                            .filter(n => n.sectionId === q.id && n.questionId === c.qid && n.optionId === Number(c.value));
                          updateQuestion.forEach((u: any, ui: any) => {
                            section.forEach((uq: any, uqi: any) => {
                              if (u.actionBySectionId == uq.id) {
                                uq.isHide = u.isHide;
                              }
                            });

                          });
                        }
                      }
                    });
                    if (this.surveyData.isprogressbar) {

                      if (q.isHide != true) {
                        this.totalQuestionCount = this.totalQuestionCount + q.questions.length;
                        q.questions.forEach((qs: any, qsi: any) => {
                          this.setProgressBarAttemptedQuesCount(qs);
                        });

                      }
                    }
                  });
                  if (this.surveyData.isprogressbar) {
                    this.attemptedPercentage = Math.round((this.attemptedQuestionCount / this.totalQuestionCount) * 100);
                  }
                }
              });

            this.surveyService.getMergeCodeSettings(this.surveyId)
              .subscribe(data => {
                this.MergeCodeSettings = data;
                var section = this.surveyForm.value.sections;
                if (this.MergeCodeSettings != null && this.MergeCodeSettings.length > 0) {
                  section.forEach((q: any, i: any) => {
                    var choiceQuestionList = q.questions.filter((q: any) =>
                      q.type.toLowerCase() === "picklist" ||
                      q.type.toLowerCase() === "multipleresponse" ||
                      q.type.toLowerCase() === "multiplechoice"
                    );
                    choiceQuestionList.forEach((c: any, ci: any) => {
                      let updateQuestion: SurveyEntity.MergeCodeSettings[];
                      updateQuestion = this.MergeCodeSettings.filter(
                        n => n.actionBySectionId == q.id && n.actionByQuestionId == c.qid /*&& n.optionId == Number(c.value)*/
                      );

                      updateQuestion.forEach((u: any, ui: any) => {
                        c.originalText = c.text;
                      });
                    });

                  });

                  section.forEach((q: any, i: any) => {
                    var choiceQuestionList = q.questions.filter(
                      (q: SurveyEntity.Question) =>
                        q.type.toLowerCase() === "picklist" ||
                        q.type.toLowerCase() === "multipleresponse"
                    );
                    choiceQuestionList.forEach((c: any, ci: any) => {
                      if (c.value != null || c.value != "") {
                        let AnsweredOptionText: string = '';
                        let tempOption: SurveyEntity.Option[];
                        let pickListOption: SurveyEntity.PickListItem[];
                        if (c.type.toLowerCase() === "picklist") {
                          pickListOption = c.pickList.filter(
                            (wh: SurveyEntity.PickListItem) => wh.value == c.value
                          );
                          if (pickListOption.length > 0) {
                            AnsweredOptionText = pickListOption[0].text;
                          }
                        }
                        if (c.type.toLowerCase() === "multipleresponse") {
                          tempOption = c.multipleResponse.filter(
                            (wh: SurveyEntity.Option) => wh.optionId == Number(c.value)
                          );
                          if (tempOption.length > 0) {
                            AnsweredOptionText = tempOption[0].name;
                          }
                        }

                        let updateQuestion: SurveyEntity.MergeCodeSettings[];
                        updateQuestion = this.MergeCodeSettings.filter(
                          (n: SurveyEntity.MergeCodeSettings) =>
                            n.sectionId == q.id && n.questionId == c.qid /*&& n.optionId == Number(c.value)*/
                        );
                        updateQuestion.forEach((u: any, ui: any) => {
                          section.forEach((uq: any, uqi: any) => {
                            let Question: SurveyEntity.Question[];
                            if (u.actionBySectionId == uq.id) {
                              Question = uq.questions.filter(
                                (n: SurveyEntity.Question) => n.qid == u.actionByQuestionId
                              );
                              if (Question != null && Question.length >= 1) {
                                if (AnsweredOptionText != '' && u.questionOption == AnsweredOptionText) {
                                  if (u.actionByQuestionOptionId > 0) {
                                    if (Question[0].type.toLowerCase() === 'picklist') {
                                      Question[0].pickList.forEach((pl, i) => {
                                        if (u.actionByQuestionOption == pl.text && pl.text.indexOf(u.mergeText) !== -1) {
                                          pl.text = pl.text.split(u.mergeText).join(AnsweredOptionText);
                                        }
                                      });
                                    }

                                    if (Question[0].type.toLowerCase() === 'multipleresponse') {
                                      Question[0].multipleResponse.forEach((mr, i) => {
                                        if (u.actionByQuestionOption == mr.value && mr.value.indexOf(u.mergeText) !== -1) {
                                          mr.name = mr.name.split(u.mergeText).join(AnsweredOptionText);
                                          mr.value = mr.value.split(u.mergeText).join(AnsweredOptionText);
                                          mr.hoverText = mr.hoverText.split(u.mergeText).join(AnsweredOptionText);
                                        }
                                      });
                                    }
                                  }
                                  else {
                                    Question[0].text = Question[0].originalText.split(u.mergeText).join(AnsweredOptionText);
                                  }
                                  //Question[0].text = Question[0].originalText.split(u.mergeText).join(AnsweredOptionText);
                                }
                              }
                            }
                          });
                        });
                      }
                    });
                    this.surveyForm.patchValue({
                      sections: section
                    });
                  });
                }
                this.http.post<SurveyEntity.DependentQuestionOptionSettings[]>(this.myAppUrl + "Survey/GetDependentQuestionOption", '',
                  {
                    headers: {
                      'Cache-Control': 'no-cache',
                      'Pragma': 'no-cache'
                    },
                    params: {
                      SurveyId: this.surveyId
                    }
                  }).subscribe(data => {
                    this.DependentOptionList = data;
                    if (this.DependentOptionList != null && this.DependentOptionList.length > 1) {
                      //this.showQuestionNumber = false;
                      var section = this.surveyForm.value.sections;

                      section.forEach((q: any, i: any) => {
                        var choiceQuestionList = q.questions.filter(
                          (q: SurveyEntity.Question) =>
                            q.type.toLowerCase() === "picklist" ||
                            q.type.toLowerCase() === "multipleresponse" ||
                            q.type.toLowerCase() === "multiplechoice"
                        );
                        choiceQuestionList.forEach((c: any, ci: any) => {
                          let updateQuestion: SurveyEntity.DependentQuestionOptionSettings[];
                          updateQuestion = this.DependentOptionList.filter(n => n.sectionId == q.id && n.questionId == c.qid);
                          section.forEach((uq: any, uqi: any) => {

                            let Question: SurveyEntity.Question[];
                            Question = uq.questions;
                            Question.forEach((q: any, qi: any) => {
                              let dependentOptions = updateQuestion.filter(x => x.actionByQuestionId == q.qid);
                              if ((q.type == "Picklist") && dependentOptions.length >= 1) {
                                q.pickList.forEach((o: any, oi: any) => {
                                  o.display = false;
                                });
                              }

                              //if ((q.type.toLowerCase() == "multipleresponse") && dependentOptions.length >= 1) {
                              //  q.multipleResponse.forEach((o, oi) => {
                              //    o.display = false;
                              //  });
                              //}

                            });
                          });
                        });
                      });
                      section.forEach((q: any, i: any) => {

                        var choiceQuestionList = q.questions.filter(
                          (q: SurveyEntity.Question) =>
                            q.type.toLowerCase() === "picklist" ||
                            q.type.toLowerCase() === "multipleresponse"
                        );
                        choiceQuestionList.forEach((c: any, ci: any) => {
                          if (c.value != null || c.value != "") {
                            let updateQuestion: SurveyEntity.DependentQuestionOptionSettings[];
                            updateQuestion = this.DependentOptionList.filter(
                              n => n.sectionId == q.id && n.questionId == c.qid && n.optionId == Number(c.value)
                            );
                            //updateQuestion.forEach((u, ui) => {
                            section.forEach((uq: any, uqi: any) => {

                              let Question: SurveyEntity.Question[];
                              Question = uq.questions;
                              Question.forEach((q: any, qi: any) => {
                                let dependentOptions = updateQuestion.filter(x => x.actionByQuestionId == q.qid);
                                if ((q.type.toLowerCase() == "picklist") && dependentOptions.length >= 1) {
                                  q.pickList.forEach((o: any, oi: any) => {
                                    let options = dependentOptions.filter(x => x.actionByOptionId.toString() == o.value);
                                    if (options != null && options.length >= 1) {
                                      o.display = true;
                                    }
                                    else {
                                      o.display = false;
                                    }
                                  });
                                }

                                if ((q.type.toLowerCase() == "multipleresponse") && dependentOptions.length >= 1) {
                                  q.multipleResponse.forEach((o: any, oi: any) => {
                                    let options = dependentOptions.filter(x => x.actionByOptionId == o.optionId);
                                    if (options != null && options.length >= 1) {
                                      o.display = true;
                                    }
                                    else {
                                      o.display = false;
                                    }
                                  });
                                }

                              });

                              //}
                            });

                            //});
                          }
                        });
                      });
                    }
                  });

                //Section for survey randomization bucket settings
                this.http.post<surveyProviderBucketSetting[]>(this.myAppUrl + this._getAllSurveyProviderBucketSettingsUrl, "",
                  {
                    headers: {
                      'Cache-Control': 'no-cache',
                      'Pragma': 'no-cache'
                    },
                    params: {
                      surveyId: this.surveyId,
                      serviceLineId: this.serviceLineId,
                      companyId: this.companyId
                    }
                  }).subscribe(result => {
                    this.surveyProviderBucketSettingsList = result;
                    var survData = this.surveyData;
                    if (this.surveyProviderBucketSettingsList.length > 0) {
                      var uid = userId;
                      var userBucketSettings = this.surveyProviderBucketSettingsList
                        .filter(x => x.entityTypeName.toLowerCase() === 'user text' && x.entityId.toString() === uid); var questionBucketSettings: surveyProviderBucketSetting[] = [];

                      if (userBucketSettings.length > 0) {
                        userBucketSettings.forEach((u: any, i: any) => {
                          var qBucketSettings = this.surveyProviderBucketSettingsList
                            .filter(x => x.entityTypeName.toLowerCase() === 'question text' && x.bucketId === u.bucketId);
                          qBucketSettings.forEach((qb: any, i: any) => {
                            questionBucketSettings.push(qb);
                          });
                        });

                        var survSections = this.surveyForm.value.sections;
                        var questionOrder: number = 1;
                        var counter: number = 0;

                        var orderedBucketSettings = questionBucketSettings
                          .filter(x => x.entityTypeName.toLowerCase() === 'question text')
                          .sort((a, b) => b.entityId - a.entityId);
                        var finalQuestion = orderedBucketSettings[0];

                        survSections.forEach((s: any, i: any) => {
                          var shownQuestionsCount: number = 0;
                          s.questions.forEach((q: any, i: any) => {
                            if (!this.lastTab) {
                              var questionBucketSettingFound = questionBucketSettings
                                .filter(x => x.entityTypeName.toLowerCase() === 'question text' && x.entityId === q.qid);
                              if (questionBucketSettingFound.length > 0) {
                                q.isShow = true;
                                counter++;
                                if (survData.showQuestionNumber) {
                                  q.order = questionOrder;
                                  q.displayNumberText = questionOrder;
                                  questionOrder++;
                                  shownQuestionsCount++;
                                }

                              }
                              else {
                                q.isShow = false;
                              }

                            }

                          });

                          if (shownQuestionsCount === 0) {
                            s.isShowSection = false;
                          }


                        })

                        if (counter > 0) {
                          this.totalQuestionCount = counter;
                        }
                      }

                    }
                  });
                //Section for Survey User Section Settings / Last saved section
                this.http.get<surveyUserSectionSetting[]>(this.myAppUrl + this._getSurveyUserSectionSettingsUrl, {
                  params: {
                    'surveyId': this.surveyId,
                    'serviceLineId': this.serviceLineId,
                    'companyId': this.companyId,
                    'userId': this.userId
                  }
                }).toPromise().then(result => {
                  this.surveyUserSectionSettingsList = result;

                  if (this.surveyUserSectionSettingsList.length > 0) {
                    var survSections = this.surveyData.metaBody.sections;
                    survSections.forEach((s: any, i: any) => {
                      var matchingSurveySectionSetting = this.surveyUserSectionSettingsList
                        .filter(x => x.sectionId === s.id);
                      if (matchingSurveySectionSetting.length > 0) {
                        var index = survSections.indexOf(s);
                        this.tabIndex = index;
                        this.activeTabId = s.id;
                        var lastItem = survSections[survSections.length - 1];
                        if (s.id == lastItem.id) {
                          this.lastTab = true;
                        }
                        else {
                          this.lastTab = false;
                        }
                        if (s.type === 'Questionnaire') {
                          this.isQuestionnaireTabActive = true;
                        }
                      }
                    });
                  }
                });
              });
          });
      });

  }
  getmatrixHeaders(question: SurveyEntity.Question): string {
    var matrixHeaders = "";

    if (this.surveyData !== undefined && this.surveyData.surveytype === 'SectionPerPageWithPlainLayout') {
      const columnData = question.matrix.columns;
      if (columnData.length > 0) {
        var columnList = columnData;
        const colspan = Math.max(...columnData.map(col => col.colspan));
        columnList.forEach((value: any, index: any) => {

          if (index == 0 && value.colspan > 0) {
            matrixHeaders = "<tr>";
            if (!question.matrix.hideRowHeader) {
              matrixHeaders = matrixHeaders + "<th style='min-width:60Px!important;font-size:10pt !important;padding-right:5px !important;'></th>";
            }
          }
          if (value.colspan > 0) {
            matrixHeaders = matrixHeaders + "<th style='min-width:60Px!important;font-size:10pt !important;padding-right:5px !important;' colspan='" + value.colspan + "'> <label style='font-size:10pt' class='form-control-label'>" + value.name + "</label></th>";
          }
          else {
            matrixHeaders = matrixHeaders + "<th style='min-width:60Px!important;font-size:10pt !important;padding-right:5px !important;' rowspan='" + colspan + "'><label style='font-size:10pt' class='form-control-label'>" + value.name + "</label></th>";
          }
          if ((question.matrix.columns.length == (index + 1))) {
            matrixHeaders = matrixHeaders + "</tr>";
          }
        });
        const childrenCols = columnData.filter(col => col.colspan > 0);
        childrenCols.forEach((value: any, index: any) => {
          if (index == 0) {
            matrixHeaders = matrixHeaders + "<tr>";
            if (!question.matrix.hideRowHeader) {
              matrixHeaders = matrixHeaders + "<td></td>";
            }

          }
          value.childColumns.forEach((cValue: any, cIndex: any) => {
            matrixHeaders = matrixHeaders + "<th style='min-width:60Px!important;font-size:10pt !important;padding-right:5px !important;'> <label style='font-size:10pt' class='form-control-label'>" + cValue + "</label></th>";
          });
          if ((index + 1) == childrenCols.length) {
            matrixHeaders = matrixHeaders + "</tr>";
          }
        });

      }
      else {
        const columnHeaderData = question.matrix.columnFields || [];
        if (question.matrix.hideRowHeader) {
          matrixHeaders = "<tr>";
        } else {
          matrixHeaders = "<tr><th style='min-width:60Px!important;font-size:10pt !important;padding-right:5px !important;'></th>";
        }
        columnHeaderData.forEach((header: any, index: any) => {
          if (header.width > 0 && header.width != undefined && header.width != null) {
            matrixHeaders = matrixHeaders + "<th style='min-width:60Px!important;font-size:10pt !important;padding-right:5px !important;width: " + header.width + "px;padding: 0;white-space: pre-line'>";
            matrixHeaders = matrixHeaders + "<label style='font-size:10pt' class='form-control-label'>";
            matrixHeaders = matrixHeaders + header.columnHeaderText;
            matrixHeaders = matrixHeaders + "</label>";
            matrixHeaders = matrixHeaders + "</th>";
          }
          else {
            matrixHeaders = matrixHeaders + "<th style='min-width:60Px!important;font-size:10pt !important;padding-right:5px !important;'>";
            matrixHeaders = matrixHeaders + "<label style='font-size:10pt' class='form-control-label'>";
            matrixHeaders = matrixHeaders + header.columnHeaderText;
            matrixHeaders = matrixHeaders + "</label>";
            matrixHeaders = matrixHeaders + "</th>";
          }
        });
        matrixHeaders = matrixHeaders + "</tr>";
      }

      //this.surveyForm.value.sections.forEach((s, i) => {
      //  s.questions.forEach((q, i) => {
      //    if (q.qid == question.qid) {
      //      q.matrix.headerInnerHTML = matrixHeaders;
      //    }
      //  });
      //});
      return matrixHeaders;
    }
    else {
      let matrixHeaders = "";
      const columnData = question.matrix.columns || [];
      if (columnData.length > 0) {
        var columnList = columnData;
        const colspan = Math.max(...columnData.map(col => col.colspan));
        columnList.forEach((value, index) => {

          if (index == 0 && value.colspan > 0) {
            matrixHeaders = "<tr>";
            if (!question.matrix.hideRowHeader) {
              matrixHeaders = matrixHeaders + "<th style='min-width:60Px!important;font-size:10pt !important;'></th>";
            }
          }
          if (value.colspan > 0) {
            matrixHeaders = matrixHeaders + "<th style='min-width:60Px!important;font-size:10pt !important;' colspan='" + value.colspan + "'> <label style='font-size:10pt' class='form-control-label'>" + value.name + "</label></th>";
          }
          else {
            matrixHeaders = matrixHeaders + "<th style='min-width:60Px!important;font-size:10pt !important;' rowspan='" + colspan + "'><label style='font-size:10pt' class='form-control-label'>" + value.name + "</label></th>";
          }
          if ((question.matrix.columns.length == (index + 1))) {
            matrixHeaders = matrixHeaders + "</tr>";
          }
        });
        const childrenCols = columnData.filter(col => col.colspan > 0);
        childrenCols.forEach((value: any, index: any) => {
          if (index == 0) {
            matrixHeaders = matrixHeaders + "<tr>";
            if (!question.matrix.hideRowHeader) {
              matrixHeaders = matrixHeaders + "<td></td>";
            }

          }
          value.childColumns.forEach((cValue: any, cIndex: any) => {
            matrixHeaders = matrixHeaders + "<th style='min-width:60Px!important;font-size:10pt !important;'> <label style='font-size:10pt' class='form-control-label'>" + cValue + "</label></th>";
          });
          if ((index + 1) == childrenCols.length) {
            matrixHeaders = matrixHeaders + "</tr>";
          }
        });

      }
      else {
        const columnHeaderData = question.matrix.columnFields || [];
        if (question.matrix.hideRowHeader) {
          matrixHeaders = "<tr>";
        } else {
          matrixHeaders = "<tr><th style='min-width:60Px!important;font-size:10pt !important;'></th>";
        }
        columnHeaderData.forEach((header: any, index: any) => {
          if (header.width > 0 && header.width != undefined && header.width != null) {
            matrixHeaders = matrixHeaders + "<th style='min-width:60Px!important;font-size:10pt !important;width: " + header.width + "px;padding: 0;white-space: pre-line'>";
            matrixHeaders = matrixHeaders + "<label style='font-size:10pt' class='form-control-label'>";
            matrixHeaders = matrixHeaders + header.columnHeaderText;
            matrixHeaders = matrixHeaders + "</label>";
            matrixHeaders = matrixHeaders + "</th>";
          }
          else {
            matrixHeaders = matrixHeaders + "<th style='min-width:60Px!important;font-size:10pt !important;'>";
            matrixHeaders = matrixHeaders + "<label style='font-size:10pt' class='form-control-label'>";
            matrixHeaders = matrixHeaders + header.columnHeaderText;
            matrixHeaders = matrixHeaders + "</label>";
            matrixHeaders = matrixHeaders + "</th>";
          }
        });
        matrixHeaders = matrixHeaders + "</tr>";
      }
      return matrixHeaders;
    }

  }

  private GetSurveyMessageListBasedOnLanguage(tmpLanguageCode: any) {
    this.surveyService.getSurveyMessagesAndLanguages(tmpLanguageCode)
      .toPromise().then(data => {
        this.surveyMessagesList = data;
        let tmpHome = data.filter(x => x.key == "home");
        if (tmpHome.length > 0 && tmpHome[0].value !== null && tmpHome[0].value !== '') {
          this.key_Home = tmpHome[0].value;
        }
        let tmpNext = data.filter(x => x.key == "next");
        if (tmpNext.length > 0 && tmpNext[0].value !== null && tmpNext[0].value !== '') {
          this.key_Next = tmpNext[0].value;
        }
        let tmpPrev = data.filter(x => x.key == "prev");
        if (tmpPrev.length > 0 && tmpPrev[0].value !== null && tmpPrev[0].value !== '') {
          this.key_Prev = tmpPrev[0].value;
        }
        let tmpSubmit = data.filter(x => x.key == "submit");
        if (tmpSubmit.length > 0 && tmpSubmit[0].value !== null && tmpSubmit[0].value !== '') {
          this.key_Submit = tmpSubmit[0].value;
        }
        let tmpHomeMessagePart1 = data.filter(x => x.key == "home_Message_Part1");
        if (tmpHomeMessagePart1.length > 0 && tmpHomeMessagePart1[0].value !== null && tmpHomeMessagePart1[0].value !== '') {
          this.key_home_Message_Part1 = tmpHomeMessagePart1[0].value;
        }
        let tmpHomeMessagePart2 = data.filter(x => x.key == "home_Message_Part2");
        if (tmpHomeMessagePart2.length > 0 && tmpHomeMessagePart2[0].value !== null && tmpHomeMessagePart2[0].value !== '') {
          this.key_home_Message_Part2 = tmpHomeMessagePart2[0].value;
        }
        let tmpkeyNote = data.filter(x => x.key == "Note");
        if (tmpkeyNote.length > 0 && tmpkeyNote[0].value !== null && tmpkeyNote[0].value !== '') {
          this.key_Note = tmpkeyNote[0].value;
        }
        let tmpkeyYes = data.filter(x => x.key == "Yes");
        if (tmpkeyYes.length > 0 && tmpkeyYes[0].value !== null && tmpkeyYes[0].value !== '') {
          this.key_Yes = tmpkeyYes[0].value;
        }
        let tmpkeyNo = data.filter(x => x.key == "No");
        if (tmpkeyNo.length > 0 && tmpkeyNo[0].value !== null && tmpkeyNo[0].value !== '') {
          this.key_No = tmpkeyNo[0].value;
        }
        let tmpkeyExitSurveyConfirmation = data.filter(x => x.key == "Exit_Survey_Confirmation");
        if (tmpkeyExitSurveyConfirmation.length > 0 && tmpkeyExitSurveyConfirmation[0].value !== null && tmpkeyExitSurveyConfirmation[0].value !== '') {
          this.key_Exit_Survey_Confirmation = tmpkeyExitSurveyConfirmation[0].value;
        }
        let tmpkeySurveySubmitPopupMessage = data.filter(x => x.key == "Survey_SubmitPopupMessage");
        if (tmpkeySurveySubmitPopupMessage.length > 0 && tmpkeySurveySubmitPopupMessage[0].value !== null && tmpkeySurveySubmitPopupMessage[0].value !== '') {
          this.key_Survey_SubmitPopupMessage = tmpkeySurveySubmitPopupMessage[0].value;
          this.SubmitPopupMessage = tmpkeySurveySubmitPopupMessage[0].value;
        }
        let tmpkeySurveySurveyAfterSubmitMessage = data.filter(x => x.key == "Survey_SurveyAfterSubmitMessage");
        if (tmpkeySurveySurveyAfterSubmitMessage.length > 0 && tmpkeySurveySurveyAfterSubmitMessage[0].value !== null && tmpkeySurveySurveyAfterSubmitMessage[0].value !== '') {
          this.key_Survey_SurveyAfterSubmitMessage = tmpkeySurveySurveyAfterSubmitMessage[0].value;
        }
        let tmpkeySurveyAllReadySubmittedSurveyMessage = data.filter(x => x.key == "Survey_AllReadySubmittedSurveyMessage");
        if (tmpkeySurveyAllReadySubmittedSurveyMessage.length > 0 && tmpkeySurveyAllReadySubmittedSurveyMessage[0].value !== null && tmpkeySurveyAllReadySubmittedSurveyMessage[0].value !== '') {
          this.key_Survey_AllReadySubmittedSurveyMessage = tmpkeySurveyAllReadySubmittedSurveyMessage[0].value;
        }
        let tmpkeySurveyExpiredSurveyMessage = data.filter(x => x.key == "Survey_ExpiredSurveyMessage");
        if (tmpkeySurveyExpiredSurveyMessage.length > 0 && tmpkeySurveyExpiredSurveyMessage[0].value !== null && tmpkeySurveyExpiredSurveyMessage[0].value !== '') {
          this.key_Survey_ExpiredSurveyMessage = tmpkeySurveyExpiredSurveyMessage[0].value;
        }
        let tmpkeySurveySubmitLabel = data.filter(x => x.key == "Survey_Submit_Label");
        if (tmpkeySurveySubmitLabel.length > 0 && tmpkeySurveySubmitLabel[0].value !== null && tmpkeySurveySubmitLabel[0].value !== '') {
          this.key_Survey_Submit_Label = tmpkeySurveySubmitLabel[0].value;
        }
        let tmpkeyClose = data.filter(x => x.key == "Close");
        if (tmpkeyClose.length > 0 && tmpkeyClose[0].value !== null && tmpkeyClose[0].value !== '') {
          this.key_Close = tmpkeyClose[0].value;
        }
        let tmpkeyWaitMessage = data.filter(x => x.key == "Wait_Message");
        if (tmpkeyWaitMessage.length > 0 && tmpkeyWaitMessage[0].value !== null && tmpkeyWaitMessage[0].value !== '') {
          this.key_Wait_Message = tmpkeyWaitMessage[0].value;
        }
        let tmpkeyWaitOF = data.filter(x => x.key == "Wait_OF");
        if (tmpkeyWaitOF.length > 0 && tmpkeyWaitOF[0].value !== null && tmpkeyWaitOF[0].value !== '') {
          this.key_Wait_OF = tmpkeyWaitOF[0].value;
        }
        let tmpkeyWaitAnswered = data.filter(x => x.key == "Wait_Answered");
        if (tmpkeyWaitAnswered.length > 0 && tmpkeyWaitAnswered[0].value !== null && tmpkeyWaitAnswered[0].value !== '') {
          this.key_Wait_Answered = tmpkeyWaitAnswered[0].value;
        }
        let tmpkeyPreviousTabSaveMessage = data.filter(x => x.key == "Previous_Tab_Save_Message");
        if (tmpkeyPreviousTabSaveMessage.length > 0 && tmpkeyPreviousTabSaveMessage[0].value !== null && tmpkeyPreviousTabSaveMessage[0].value !== '') {
          this.key_Previous_Tab_Save_Message = tmpkeyPreviousTabSaveMessage[0].value;
        }
        let tmpkeyPreviousTabSaveTitle = data.filter(x => x.key == "Previous_Tab_Save_Title");
        if (tmpkeyPreviousTabSaveTitle.length > 0 && tmpkeyPreviousTabSaveTitle[0].value !== null && tmpkeyPreviousTabSaveTitle[0].value !== '') {
          this.key_Previous_Tab_Save_Title = tmpkeyPreviousTabSaveTitle[0].value;
        }
        let tmpkeyNextValidationMessage = data.filter(x => x.key == "Next_Validation_Message");
        if (tmpkeyNextValidationMessage.length > 0 && tmpkeyNextValidationMessage[0].value !== null && tmpkeyNextValidationMessage[0].value !== '') {
          this.key_Next_Validation_Message = tmpkeyNextValidationMessage[0].value;
        }
        let tmpkeySurveySaveForLater = data.filter(x => x.key == "Survey_SaveForLater");
        if (tmpkeySurveySaveForLater.length > 0 && tmpkeySurveySaveForLater[0].value !== null && tmpkeySurveySaveForLater[0].value !== '') {
          this.key_Survey_SaveForLater = tmpkeySurveySaveForLater[0].value;
        }
      });
  }
  getSections(form: any) {
    return form.controls.sections.controls;
  }
  getQuestions(form: any) {
    return form.controls.questions.controls;
  }

  getMatrix(form: any) {
    return form.controls.matrix.controls;
  }
  uploadSectionDocuments() {

  }
  onGridReady(params: any) {
    this.gridapi = params.api;
    params.api.sizeColumnsToFit();
  }
  onSectionGridReady(params: any) {
    this.sectiongridapi = params.api;
    params.api.sizeColumnsToFit();
  }
  generalDeleteDocument(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    element.setAttribute('data-toggle', 'modal');
    element.setAttribute('href', '#deleteDocumentconfirmationModel');
    elementI.setAttribute('class', 'fa  fa-trash anchor-cursor');
    this.renderer.appendChild(element, elementI);

    this.renderer.listen(element, 'click', () => { this.currentDeletingdocumentId = params.data.documentId });
    return element;

  }
  onPreferredLanguageSelect() {
    var preferredLangId = this.usersurveysettings.value.preferredLanguageId;
    this.preferredLanguageId = this.usersurveysettings.value.preferredLanguageId;
    var preferredLanguageCodes = this.surveyProviderLanguageMappedDetails
      .filter(x => x.languageId === this.preferredLanguageId)
      .map(x => x.languageCode);
    this.preferredLanguageCode = preferredLanguageCodes[0];
    this.languageCode = preferredLanguageCodes[0];
    this.loadSurveyPreferredLanguage(this.preferredLanguageCode);
  }

  public generalDocumentColumnDefs: (ColDef<SurveyEntity.uploadedDocuments, any> | ColGroupDef<SurveyEntity.uploadedDocuments>)[] = [
    { headerName: 'Document Id', field: 'documentId', hide: true },
    { headerName: 'Document Name', field: 'documentName', width: 400, resizable: true },
    { headerName: 'File Name', field: 'fileName', width: 500, resizable: true },
    { headerName: 'Download', cellRenderer: this.DocumentDownLoad.bind(this), resizable: true },
    //{ headerName: 'File Type', field: 'fileType', hide: true },
    { headerName: 'Delete', cellRenderer: this.generalDeleteDocument.bind(this), width: 120, resizable: true }
  ];
  public documentColumnDefs: (ColDef<SurveyEntity.uploadedDocuments, any> | ColGroupDef<SurveyEntity.uploadedDocuments>)[] = [
    { headerName: 'Document Id', field: 'documentId', hide: true },
    { headerName: 'Document Name', field: 'documentName', width: 400, resizable: true },
    { headerName: 'File Name', field: 'fileName', width: 375, resizable: true },
    { headerName: 'Download', cellRenderer: this.DocumentDownLoad.bind(this), width: 120, resizable: true }, // <-- field removed
    { headerName: 'Delete', cellRenderer: this.DeleteDocument.bind(this), width: 120, resizable: true }      // <-- field removed
  ];
  DeleteDocument(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    element.setAttribute('data-toggle', 'modal');
    element.setAttribute('href', '#deleteDocumentconfirmationModel');
    elementI.setAttribute('class', 'fa  fa-trash anchor-cursor');
    this.renderer.appendChild(element, elementI);

    this.renderer.listen(element, 'click', () => { this.currentDeletingdocumentId = params.data.documentId });
    return element;

  }
  loadSurveyPreferredLanguage(preferredLang: any) {
    let userId = this.EncrDecr.get(localStorage.getItem('userId') ?? '-1');
    var preferredLanguage = preferredLang;
    this.userId = userId;
    this.docForm = new FormGroup({
      documentname: new FormControl(null),
      file: new FormControl(null, Validators.required)
    });
    this.sectionDocs = new FormGroup({
      documentname: new FormControl(null),
      file: new FormControl(null, Validators.required)
    });
    this.selectedSection.Name = 'Default Section';
    this.sectionForm = new FormGroup({
      documentname: new FormControl(null, Validators.required),
      sectionConfirmation: new FormControl('AT')
    });

    this.http.get<SurveyProviderLanguageMappedDetails[]>("/Survey/GetSurveyProviderLanguageMappedDetails",
      {
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        },
        params: {
          'surveyId': this.surveyId.toString(),
          'serviceLineId': this.serviceLineId.toString(),
          'companyId': this.companyId.toString()
        }
      }).toPromise().then(data => {
        this.surveyProviderLanguageMappedDetails = data;
        var surveyLanguageMappedDetails = this.surveyProviderLanguageMappedDetails;
      });


    this.surveyService.getSurveySchema(this.surveyId, this.serviceLineId, this.isPreview, this.companyId)
      .subscribe(data => {
        this.surveyData = data;

        var survData = this.surveyData;

        if (this.ssUserId === '-1') {
          this.surveyData.userId = parseInt(this.ssUserId);
        }

        let qSectionExists: boolean = false;

        this.surveyData.metaBody.sections = this.surveyData.metaBody.sections
          .slice()
          .sort((a, b) => a.order - b.order);
        this.surveyData.metaBody.sections.forEach((s: any, i: any) => {
          if (s.type != 'Questionnaire') {
            if (s.isConfirmationRequires && (!s.isConfirmed)) {
              this.isAllSectionConfirmed = false;

            }
            this.dSections.push(s);
          }
          if (s.type == 'Questionnaire' && qSectionExists == false) {
            this.dSections.push(s);
            qSectionExists = true;
          }

        });



        this.qSections = this.surveyData.metaBody.sections
          .filter(wh => wh.type === 'Questionnaire')
          .sort((a, b) => a.qSOrder - b.qSOrder);
        this.iSections = this.surveyData.metaBody.sections
          .filter(wh => wh.type === 'Informational')
          .sort((a, b) => a.order - b.order);
        this.qSections.forEach((q: any, i: any) => {
          this.totalQuestionCount = this.totalQuestionCount + q.questions.length;
          q.questions.forEach((qs: any, qsi: any) => {
            if (this.surveyData.isprogressbar) {
              this.setProgressBarAttemptedQuesCount(qs);
            }

            if (qs.type.toLowerCase() === "slider") {
            }
            if (qs.type.toLowerCase() === "rankingsort" && qs.value != '') {
              this.setRankingSortOrder(qs);
            }
            qs.matrix.rowdataFields.forEach((r: any, ri: any) => {
              qs.matrix.columnFields.forEach((c: any, ci: any) => {
                const cell: SurveyEntity.CellReference = {
                  cellAddress: [r.rowItemId, c.columnItemId],
                  value: '',
                  smqid: 0
                };
                var IsCellEx = r.cellReferences.some(
                  (n: any) => n.cellAddress.length > 0 && n.cellAddress[0] === r.rowItemId && n.cellAddress[1] === c.columnItemId
                );
                if (!IsCellEx) {
                  r.cellReferences.push(cell);
                }
              });
            });
          })
        });
        if (this.surveyData.isprogressbar) {
          this.attemptedPercentage = Math.round((this.attemptedQuestionCount / this.totalQuestionCount) * 100);
        }
        try {
          this.surveyData.metaBody.uploadedDocumentsList = Array.from(this.surveyData.metaBody.uploadedDocumentsList);
        }
        catch (e) {
          alert(e);
        }
        if (this.isPreview && localStorage.getItem('fromModule') != null) {
          this.surveyData.fromModule = localStorage.getItem('fromModule') ?? '';

        }
        else {
          localStorage.setItem('fromModule', "Provider");
          this.surveyData.fromModule = "Provider";
        }

        this.surveyForm = this.formBuilder.group({
          responseId: new FormControl(this.surveyData.responseId),
          serviceLineId: new FormControl(this.serviceLineId),//this.surveyData.serviceLineId
          companyId: new FormControl(this.companyId),//this.surveyData.companyId
          userId: new FormControl(this.EncrDecr.get(localStorage.getItem('userId') ?? '-1')),//this.surveyData.userId
          surveyId: new FormControl(this.surveyData.surveyId),//this.surveyData.surveyId
          surveytitle: new FormControl(this.surveyData.surveytitle),
          surveydesctiption: new FormControl(""),
          surveytype: new FormControl(this.surveyData.surveytype),
          isautosave: new FormControl(this.surveyData.isautosave),
          isprogressbar: new FormControl(this.surveyData.isprogressbar),
          perpage: new FormControl(this.surveyData.perpage),
          sections: this.initSection(this.qSections),
          flagChanges: this.formDirty,
          isPreview: this.isPreview,
        });

        this.usersurveysettings = this.formBuilder.group({
          surveyLanguage: new FormControl(""),
          preferredLanguageId: new FormControl('')
        });

        this.showQuestionNumber = data.showQuestionNumber;
        this.showQuestionPrefix = data.showQuestionPrefix;
        this.surveyForm.valueChanges.subscribe(value => {
          /*  console.log('changed');*/
          this.markAsFormChange();
          this.updateProgressBar();
        });

        this.selectedSection.Name = this.qSections[0].name;
        this.selectedSection.Id = this.qSections[0].id;
        var tabs = this.surveyData.metaBody.sections;
        this.activeTabId = tabs[0].id;
        this.surveyService.getCompanyLogo(this.serviceLineId, this.surveyId)
          .subscribe(response => {
            this.companyLogo = response.logo;
            this.workspaceLogo = response.workspaceLogo;
            this.GetSurveyMessageListBasedOnLanguage(this.languageCode);

            this.surveyService.getSurveyMessages(this.serviceLineId, this.surveyId)
              .toPromise().then((data: any) => {

                //this.translate.get(['key.home', 'key.next', 'key.prev', 'key.submit', 'key.home.Message.Part1', 'key.home.Message.Part2', 'key.Note', 'key.Yes', 'key.No', 'key.Exit.Survey.Confirmation', 'key.Survey.SubmitPopupMessage', 'key.Survey.SurveyAfterSubmitMessage', 'key.Survey.AllReadySubmittedSurveyMessage', 'key.Survey.ExpiredSurveyMessage', 'key.Survey.Submit.Label', 'key.Close', 'key.Wait.Message', 'key.Wait.OF', 'key.Wait.Answered', 'key.Previous.Tab.Save.Message', 'key.Previous.Tab.Save.Title', 'key.Next.Validation.Message', 'key.Survey.SaveForLater'])
                //  .toPromise().then(translations => {
                //this.key_Home = translations['key.home'];
                //this.key_Next = translations['key.next'];
                //this.key_Prev = translations['key.prev'];
                //this.key_home_Message_Part1 = translations['key.home.Message.Part1'];
                //this.key_home_Message_Part2 = translations['key.home.Message.Part2'];
                //this.key_Note = translations['key.Note'];
                //this.key_Yes = translations['key.Yes'];
                //this.key_No = translations['key.No'];
                //this.key_Exit_Survey_Confirmation = translations['key.Exit.Survey.Confirmation'];
                //this.key_Survey_SubmitPopupMessage = translations['key.Survey.SubmitPopupMessage'];
                //this.key_Survey_SurveyAfterSubmitMessage = translations['key.Survey.SurveyAfterSubmitMessage'];
                //this.key_Survey_AllReadySubmittedSurveyMessage = translations['key.Survey.AllReadySubmittedSurveyMessage'];
                //this.key_Survey_ExpiredSurveyMessage = translations['key.Survey.ExpiredSurveyMessage'];
                //this.key_Survey_Submit_Label = translations['key.Survey.Submit.Label'];
                //this.key_Close = translations['key.Close'];
                //this.key_Submit = translations['key.submit'];
                //this.key_Wait_Message = translations['key.Wait.Message'];
                //this.key_Wait_OF = translations['key.Wait.OF'];
                //this.key_Wait_Answered = translations['key.Wait.Answered'];
                //this.key_Previous_Tab_Save_Message = translations['key.Previous.Tab.Save.Message'];
                //this.key_Previous_Tab_Save_Title = translations['key.Previous.Tab.Save.Title'];
                //this.key_Next_Validation_Message == translations['key.Next.Validation.Message'];
                //this.key_Survey_SaveForLater = translations['key.Survey.SaveForLater'];

                var saveLaterTranslation = this.key_Survey_SaveForLater;


                if (data[0].key == 'SurveyAfterSubmitMessage') {
                  this.SurveyAfterSubmitMessage = data[0].value;
                  if (this.languageCode == "it") {
                    this.SurveyAfterSubmitMessage = this.key_Survey_SurveyAfterSubmitMessage;
                  }
                }
                if (data[1].key == 'AllReadySubmittedSurveyMessage') {
                  this.AllReadySubmittedSurveyMessage = data[1].value;
                  if (this.languageCode == "it") {
                    this.AllReadySubmittedSurveyMessage = this.key_Survey_AllReadySubmittedSurveyMessage;
                  }
                }
                if (data[2].key == 'ExpiredSurveyMessage') {
                  this.ExpiredSurveyMessage = data[2].value;
                  if (this.languageCode == "it") {
                    this.ExpiredSurveyMessage = this.key_Survey_ExpiredSurveyMessage;
                  }
                }
                if (data[3].key == 'ForcefullyExited') {
                  this.ForcefullyExited = data[3].value;
                }
                if (data[4].key == 'AlreadyForcefullyExited') {
                  this.AlreadyForcefullyExited = data[4].value;
                }
                if (data[5].key == 'ForcefullyExitedBackToSurvey') {
                  this.ForcefullyExitedBackToSurvey = data[5].value;
                }
                if (data[6].key == 'SubmitPopupMessage') {
                  //   this.SubmitPopupMessage = data[6].value;
                  this.SubmitPopupMessage = this.key_Survey_SubmitPopupMessage;
                  if (this.languageCode == "it") {
                    this.SubmitPopupMessage = this.key_Survey_SubmitPopupMessage;
                  }
                }

              });

            this.fetchSurveyLanguages();

            this.surveyService.getQuestionLanguageSettings()
              .toPromise().then(data => {
                this.questionLanguageSettingsList = data;
                if (this.questionLanguageSettingsList !== null && this.questionLanguageSettingsList.length > 0 && this.surveyProviderLanguageMappedDetails !== null) {
                  //Get translations for all static text
                  var languageCode = preferredLanguage;
                  if (languageCode !== '' && languageCode !== null && languageCode != undefined) {
                    this.surveyLanguageCode = languageCode;
                    //this.translate.use(languageCode);
                    this.preferredLanguageSet = true;
                    this.GetSurveyMessageListBasedOnLanguage(this.surveyLanguageCode);
                  }


                  var dSec = this.dSections.filter(x => x.type && x.type.toLowerCase() !== 'questionnaire');
                  dSec.forEach((ds: any, z: any) => {
                    var sectLanguageList = this.questionLanguageSettingsList
                      .filter(x =>
                        x.entityTypeText.toLowerCase() === "informational section" &&
                        x.languageId === this.preferredLanguageId &&
                        x.entityId === ds.id
                      );
                    if (sectLanguageList.length > 0) {
                      var languageText = sectLanguageList[0].languageText;
                      ds.description = languageText;
                    }

                  });

                  this.surveyForm.value.sections.forEach((s: any, i: any) => {
                    s.questions.forEach((q: any, i: any) => {
                      var i1 = 0;
                      var questionLanguageList = this.questionLanguageSettingsList
                        .filter(x => x.questionId === q.qid && x.languageId === this.preferredLanguageId);
                      questionLanguageList.forEach((qls: any, i: any) => {

                        var languageText = qls.languageText;

                        if (qls.entityTypeText.toLowerCase() === 'question text') {
                          q.text = languageText;
                          var sForm = this.surveyForm;
                          var sections = this.getSections(this.surveyForm);
                        }
                        if (qls.entityTypeText.toLowerCase() === 'option text') {
                          var option: any;
                          if (q.type.toLowerCase() === 'multipleresponse') {
                            option = (q.multipleResponse as SurveyEntity.Option[]).find(x => x.optionId === qls.entityId);
                            option.name = languageText;
                          }
                          if (q.type.toLowerCase() === 'multiplechoice') {
                            option = (q.multipleChoice as SurveyEntity.Option[]).find(x => x.optionId === qls.entityId);
                            option.name = languageText;
                          }
                          if (q.type.toLowerCase() === 'picklist') {
                            option = q.pickList.find((x: SurveyEntity.PickListItem) => x.value === qls.entityId.toString());
                            option.text = languageText;
                          }
                          if (q.type.toLowerCase() === 'rankingsort') {
                            option = q.rankingSort.find((x: any) => x.optionId === qls.entityId);
                            option.name = qls.languageText;
                          }
                          if (q.type.toLowerCase() === 'slider') {
                            option = q.slider.find((x: any) => x.rangeId === qls.entityId);
                            option.rangeDescription = qls.languageText;

                          }

                        }
                        if (qls.entityTypeText.toLowerCase() === 'column item text') {

                          //var columnItem = Enumerable.asEnumerable<any>(q.matrix.columnFields).FirstOrDefault(x => x.columnItemId == qls.entityId);
                          //   q.matrix.columns[i1].childColumns[0] = qls.languageText;

                          //   i1++;
                          //  columnItem.columnHeaderText = qls.languageText;
                        }
                        if (qls.entityTypeText.toLowerCase() === 'row item text') {
                          var rowItem: any;
                          rowItem = q.matrix.rowdataFields.find((x: any) => x.rowItemId === qls.entityId);
                          rowItem.rowText = languageText;
                        }
                      });



                      if (q.type.toLowerCase() === 'matrix') {
                        var matrixHeaders = this.getmatrixHeaders(q);
                        q.matrix.headerInnerHTML = matrixHeaders;
                      }

                    });
                  });

                  var section = this.surveyForm.value.sections;

                  //Code logic just for the sliders in survey rendering
                  section.forEach((q: any, i: any) => {
                    q.questions.forEach((qs: any, i: any) => {
                      if (qs.type.toLowerCase() === 'slider') {

                        this.setSliderValue(qs.slider);
                        this.objOptions = {
                          tmpOptions: this.options,
                          questionId: qs.qid,
                          sectionId: q.id
                        };
                        this.optionList.push(this.objOptions);
                      }
                    });
                  });

                  this.surveyForm.patchValue({
                    sections: section
                  });
                }
              });


            this.surveyService.getAdaptiveAssessmentSettings(this.surveyId).subscribe(data => {
              this.AdaptiveSettings = data;
              if (this.AdaptiveSettings != null && this.AdaptiveSettings.length > 1) {
                //this.showQuestionNumber = false;
                var section = this.surveyForm.value.sections;
                section.forEach((sq: any, si: any) => {
                  let updateQuestion: SurveyEntity.AdaptiveAssessmentSettings[];
                  updateQuestion = this.AdaptiveSettings.filter((n: SurveyEntity.AdaptiveAssessmentSettings) => n.actionBySectionId === sq.id);
                  updateQuestion.forEach((uq: any, uqi: any) => {
                    let Question: SurveyEntity.Question[];
                    Question = (sq.questions as SurveyEntity.Question[]).filter(n => n.qid === uq.actionByQuestionId);
                    if (Question != null && Question.length >= 1) {
                      Question[0].isShow = false;
                    }
                  });

                });

                section.forEach((q: any, i: any) => {

                  var choiceQuestionList = q.questions.filter((q: any) =>
                    q.type &&
                    (
                      q.type.toLowerCase() === "picklist" ||
                      q.type.toLowerCase() === "multipleresponse" ||
                      q.type.toLowerCase() === "multiplechoice"
                    )
                  );
                  choiceQuestionList.forEach((c: any, ci: any) => {
                    if (c.value != null || c.value != "") {
                      if (c.type.toLowerCase() == 'multiplechoice') {
                        let showQuestionList: string[] = [];
                        let hideQuestionList: string[] = [];
                        let selectedOptionList: number[] = [];



                        selectedOptionList = c.value.split(',').map(function (item: any) {
                          return parseInt(item, 10);
                        });
                        let showSetting = (this.AdaptiveSettings || []).filter(n => n.questionId === c.qid && n.sectionId === q.id && n.isShow === true);
                        showSetting.forEach((o: any, oi: any) => {
                          let tempSectionId: string = o.actionBySectionId.toString();
                          let tempQuestionId: string = o.actionByQuestionId.toString();
                          if (selectedOptionList.findIndex(x => x == o.optionId) >= 0 && showQuestionList.findIndex(x => x == tempSectionId + ',' + tempQuestionId) <= -1) {
                            showQuestionList.push(tempSectionId + ',' + tempQuestionId);
                          }
                        });


                        let hideSetting = (this.AdaptiveSettings || []).filter(n => n.questionId === c.qid && n.sectionId === q.id && n.isShow === false);
                        hideSetting.forEach((o: any, oi: any) => {
                          let tempSectionId: string = o.actionBySectionId.toString();
                          let tempQuestionId: string = o.actionByQuestionId.toString();
                          if (showQuestionList.findIndex(x => x === (tempSectionId + ',' + tempQuestionId)) <= -1 && hideQuestionList.findIndex(x => x === (tempSectionId + ',' + tempQuestionId)) <= -1) {
                            hideQuestionList.push(tempSectionId + ',' + tempQuestionId);
                          }
                        });

                        var questionSection = this.surveyForm.value.sections;
                        questionSection.forEach((s: any, i: any) => {
                          s.questions.forEach((qs: any, qsi: any) => {
                            let tempSectionId: string = s.id.toString();
                            let tempQuestionId: string = qs.qid.toString();
                            if (showQuestionList.findIndex(x => x === (tempSectionId + ',' + tempQuestionId)) > -1) {
                              qs.isShow = true;
                            }
                            if (hideQuestionList.findIndex(x => x === (tempSectionId + ',' + tempQuestionId)) > -1) {
                              qs.isShow = false;
                            }
                          });
                        });
                      }
                      else {
                        let updateQuestion: SurveyEntity.AdaptiveAssessmentSettings[];
                        updateQuestion = (this.AdaptiveSettings || []).filter(n => n.sectionId === q.id && n.questionId === c.qid && n.optionId === Number(c.value));
                        updateQuestion.forEach((u: any, ui: any) => {
                          section.forEach((uq: any, uqi: any) => {

                            let Question: SurveyEntity.Question[];
                            if (u.actionBySectionId == uq.id) {
                              Question = (uq.questions || []).filter((n: any) => n.qid === u.actionByQuestionId);
                              if (Question != null && Question.length >= 1) {
                                if (u.isShow == true) {
                                  Question[0].isShow = true;
                                }
                                else if (u.isShow == false) {
                                  Question[0].isShow = false;
                                }
                              }
                            }
                          });

                        });
                      }
                    }
                  });
                });

              }
            });

            this.http.post<SurveyEntity.OptionAndSectionSettings[]>("/Survey/GetOptionAndSectionSettings", '',
              {
                headers: {
                  'Cache-Control': 'no-cache',
                  'Pragma': 'no-cache'
                },
                params: {
                  SurveyId: this.surveyId
                }
              }).subscribe(data => {
                this.OptionAndSectionList = data;
                if (this.OptionAndSectionList != null && this.OptionAndSectionList.length > 1) {
                  this.totalQuestionCount = 0;
                  this.attemptedQuestionCount = 0;
                  this.attemptedPercentage = 0;
                  var section = this.surveyForm.value.sections;
                  this.totalQuestionCount = 0;
                  section.forEach((q: any, i: any) => {
                    var choiceQuestionList = (q.questions || []).filter((q: any) =>
                      q.type &&
                      (
                        q.type.toLowerCase() === "picklist" ||
                        q.type.toLowerCase() === "multipleresponse" ||
                        q.type.toLowerCase() === "multiplechoice"
                      )
                    );
                    choiceQuestionList.forEach((c: any, ci: any) => {
                      if (c.value != null || c.value != "") {
                        if (c.type.toLowerCase() == 'multiplechoice') {
                          let showSectionList: number[] = [];
                          let hideSectionList: number[] = [];
                          let selectedOptionList: number[] = [];

                          selectedOptionList = c.value.split(',').map(function (item: any) {
                            return parseInt(item, 10);
                          });

                          let showSetting = (this.OptionAndSectionList as SurveyEntity.OptionAndSectionSettings[])
                            .filter(n => n.questionId === c.qid && n.sectionId === q.id && n.isHide === false); showSetting.forEach((o: any, oi: any) => {
                              if (selectedOptionList.findIndex(x => x == o.optionId) >= 0 && showSectionList.findIndex(x => x === o.actionBySectionId) <= -1) {
                                showSectionList.push(o.actionBySectionId);
                              }
                            });


                          let hideSetting = (this.OptionAndSectionList as SurveyEntity.OptionAndSectionSettings[])
                            .filter(n => n.questionId === c.qid && n.sectionId === q.id && n.isHide === true);
                          hideSetting.forEach((o: any, oi: any) => {
                            if (showSectionList.findIndex(x => x == o.actionBySectionId) <= -1 && hideSectionList.findIndex(x => x === o.actionBySectionId) <= -1) {
                              hideSectionList.push(o.actionBySectionId);
                            }
                          });

                          var questionSection = this.surveyForm.value.sections;
                          questionSection.forEach((q: any, i: any) => {
                            if (showSectionList.findIndex(x => x === q.id) > -1) {
                              q.isHide = false;
                            }
                            if (hideSectionList.findIndex(x => x === q.id) > -1) {
                              q.isHide = true;
                            }
                          });
                        }
                        else {
                          let updateQuestion: SurveyEntity.OptionAndSectionSettings[];
                          updateQuestion = (this.OptionAndSectionList as SurveyEntity.OptionAndSectionSettings[])
                            .filter(n => n.sectionId === q.id && n.questionId === c.qid && n.optionId === Number(c.value));
                          updateQuestion.forEach((u: any, ui: any) => {
                            section.forEach((uq: any, uqi: any) => {
                              if (u.actionBySectionId == uq.id) {
                                uq.isHide = u.isHide;
                              }
                            });

                          });
                        }
                      }
                    });
                    if (this.surveyData.isprogressbar) {

                      if (q.isHide != true) {
                        this.totalQuestionCount = this.totalQuestionCount + q.questions.length;
                        q.questions.forEach((qs: any, qsi: any) => {
                          this.setProgressBarAttemptedQuesCount(qs);
                        });

                      }
                    }
                  });
                  if (this.surveyData.isprogressbar) {
                    this.attemptedPercentage = Math.round((this.attemptedQuestionCount / this.totalQuestionCount) * 100);
                  }
                }
              });


            this.surveyService.getMergeCodeSettings(this.surveyId).subscribe(data => {
              this.MergeCodeSettings = data;
              var section = this.surveyForm.value.sections;
              if (this.MergeCodeSettings != null && this.MergeCodeSettings.length > 0) {
                section.forEach((q: any, i: any) => {
                  var choiceQuestionList = (q.questions as SurveyEntity.Question[]).slice();
                  choiceQuestionList.forEach((c: any, ci: any) => {
                    let updateQuestion: SurveyEntity.MergeCodeSettings[];
                    updateQuestion = (this.MergeCodeSettings as SurveyEntity.MergeCodeSettings[])
                      .filter(n => n.actionBySectionId === q.id && n.actionByQuestionId === c.qid /*&& n.optionId == Number(c.value)*/);

                    updateQuestion.forEach((u: any, ui: any) => {
                      c.originalText = c.text;
                    });
                  });

                });

                section.forEach((q: any, i: any) => {
                  var choiceQuestionList = (q.questions as SurveyEntity.Question[])
                    .filter(q => q.type.toLowerCase() === "picklist" || q.type.toLowerCase() === "multipleresponse");
                  choiceQuestionList.forEach((c: any, ci: any) => {
                    if (c.value != null || c.value != "") {
                      let AnsweredOptionText: string = '';
                      let tempOption: SurveyEntity.Option[];
                      let pickListOption: SurveyEntity.PickListItem[];
                      if (c.type.toLowerCase() === "picklist") {
                        pickListOption = (c.pickList as SurveyEntity.PickListItem[])
                          .filter(wh => wh.value == c.value);
                        if (pickListOption.length > 0) {
                          AnsweredOptionText = pickListOption[0].text;
                        }
                      }
                      if (c.type.toLowerCase() === "multipleresponse") {
                        tempOption = (c.multipleResponse as SurveyEntity.Option[]).filter(wh => wh.optionId === Number(c.value)); if (tempOption.length > 0) {
                          AnsweredOptionText = tempOption[0].name;
                        }
                      }

                      let updateQuestion: SurveyEntity.MergeCodeSettings[];
                      updateQuestion = (this.MergeCodeSettings as SurveyEntity.MergeCodeSettings[]).filter(n => n.sectionId === q.id && n.questionId === c.qid /*&& n.optionId == Number(c.value)*/);
                      updateQuestion.forEach((u: any, ui: any) => {
                        section.forEach((uq: any, uqi: any) => {
                          let Question: SurveyEntity.Question[];
                          if (u.actionBySectionId == uq.id) {
                            Question = (uq.questions as SurveyEntity.Question[]).filter(n => n.qid === u.actionByQuestionId);
                            if (Question != null && Question.length >= 1) {
                              if (AnsweredOptionText != '' && u.questionOption == AnsweredOptionText) {
                                if (u.actionByQuestionOptionId > 0) {
                                  if (Question[0].type.toLowerCase() === 'picklist') {
                                    Question[0].pickList.forEach((pl, i) => {
                                      if (u.actionByQuestionOption == pl.text && pl.text.indexOf(u.mergeText) !== -1) {
                                        pl.text = pl.text.split(u.mergeText).join(AnsweredOptionText);
                                      }
                                    });
                                  }

                                  if (Question[0].type.toLowerCase() === 'multipleresponse') {
                                    Question[0].multipleResponse.forEach((mr, i) => {
                                      if (u.actionByQuestionOption == mr.value && mr.value.indexOf(u.mergeText) !== -1) {
                                        mr.name = mr.name.split(u.mergeText).join(AnsweredOptionText);
                                        mr.value = mr.value.split(u.mergeText).join(AnsweredOptionText);
                                        mr.hoverText = mr.hoverText.split(u.mergeText).join(AnsweredOptionText);
                                      }
                                    });
                                  }
                                }
                                else {
                                  Question[0].text = Question[0].originalText.split(u.mergeText).join(AnsweredOptionText);
                                }
                                //Question[0].text = Question[0].originalText.split(u.mergeText).join(AnsweredOptionText);
                              }
                            }
                          }
                        });
                      });
                    }
                  });
                });


                this.surveyForm.patchValue({
                  sections: section
                });
              }
            });



            this.http.post<SurveyEntity.DependentQuestionOptionSettings[]>("/Survey/GetDependentQuestionOption", '',
              {
                headers: {
                  'Cache-Control': 'no-cache',
                  'Pragma': 'no-cache'
                },
                params: {
                  SurveyId: this.surveyId
                }
              }).subscribe(data => {
                this.DependentOptionList = data;
                if (this.DependentOptionList != null && this.DependentOptionList.length > 1) {
                  //this.showQuestionNumber = false;
                  var section = this.surveyForm.value.sections;

                  section.forEach((q: any, i: any) => {

                    var choiceQuestionList = (q.questions as SurveyEntity.Question[]).filter(q => q.type.toLowerCase() === "picklist" || q.type.toLowerCase() === "multipleresponse");
                    choiceQuestionList.forEach((c: any, ci: any) => {
                      let updateQuestion: SurveyEntity.DependentQuestionOptionSettings[];
                      updateQuestion = (this.DependentOptionList as SurveyEntity.DependentQuestionOptionSettings[]).filter(n => n.sectionId === q.id && n.questionId === c.qid);
                      section.forEach((uq: any, uqi: any) => {

                        let Question: SurveyEntity.Question[];
                        Question = (uq.questions as SurveyEntity.Question[]);
                        Question.forEach((q: any, qi: any) => {
                          let dependentOptions = updateQuestion.filter(x => x.actionByQuestionId == q.qid);
                          if (q.type.toLowerCase() == "picklist" && dependentOptions.length >= 1) {
                            q.pickList.forEach((o: any, oi: any) => {
                              o.display = false;
                            });
                          }

                          //if (q.type.toLowerCase() == "multipleresponse" && dependentOptions.length >= 1) {
                          //  q.multipleResponse.forEach((o, oi) => {
                          //    o.display = false;
                          //  });
                          //}

                        });
                      });
                    });
                  });

                  section.forEach((q: any, i: any) => {

                    var choiceQuestionList = (q.questions as SurveyEntity.Question[]).filter(q => q.type.toLowerCase() === "picklist" || q.type.toLowerCase() === "multipleresponse");
                    choiceQuestionList.forEach((c: any, ci: any) => {
                      if (c.value != null || c.value != "") {
                        let updateQuestion: SurveyEntity.DependentQuestionOptionSettings[];
                        updateQuestion = (this.DependentOptionList as SurveyEntity.DependentQuestionOptionSettings[])
                          .filter(n => n.sectionId === q.id && n.questionId === c.qid && n.optionId === Number(c.value));
                        //updateQuestion.forEach((u, ui) => {
                        section.forEach((uq: any, uqi: any) => {

                          let Question: SurveyEntity.Question[];
                          Question = Array.isArray(uq.questions) ? uq.questions : Array.from(uq.questions);
                          Question.forEach((q: any, qi: any) => {
                            let dependentOptions = updateQuestion.filter(x => x.actionByQuestionId == q.qid);
                            if ((q.type.toLowerCase() == "picklist") && dependentOptions.length >= 1) {
                              q.pickList.forEach((o: any, oi: any) => {
                                let options = dependentOptions.filter(x => x.actionByOptionId.toString() == o.value);
                                if (options != null && options.length >= 1) {
                                  o.display = true;
                                }
                                else {
                                  o.display = false;
                                }
                              });
                            }

                            if ((q.type.toLowerCase() == "multipleresponse") && dependentOptions.length >= 1) {
                              q.multipleResponse.forEach((o: any, oi: any) => {
                                let options = dependentOptions.filter(x => x.actionByOptionId == o.optionId);
                                if (options != null && options.length >= 1) {
                                  o.display = true;
                                }
                                else {
                                  o.display = false;
                                }
                              });
                            }

                          });

                          //}
                        });

                        //});
                      }
                    });
                  });

                }
              });


            //Section for survey randomization bucket settings
            this.http.post<surveyProviderBucketSetting[]>(this.myAppUrl + this._getAllSurveyProviderBucketSettingsUrl, "",
              {
                headers: {
                  'Cache-Control': 'no-cache',
                  'Pragma': 'no-cache'
                },
                params: {
                  surveyId: this.surveyId,
                  serviceLineId: this.serviceLineId,
                  companyId: this.companyId
                }
              }).subscribe(result => {
                this.surveyProviderBucketSettingsList = result;

                var survData = this.surveyData;

                if (this.surveyProviderBucketSettingsList.length > 0) {
                  var uid = userId;
                  var userBucketSettings = this.surveyProviderBucketSettingsList
                    .filter(x => x.entityTypeName.toLowerCase() === 'user text' && x.entityId.toString() === uid);
                  var questionBucketSettings: surveyProviderBucketSetting[] = [];

                  if (userBucketSettings.length > 0) {
                    userBucketSettings.forEach((u: any, i: any) => {
                      var qBucketSettings = this.surveyProviderBucketSettingsList
                        .filter(x => x.entityTypeName.toLowerCase() === 'question text' && x.bucketId === u.bucketId);
                      qBucketSettings.forEach((qb: any, i: any) => {
                        questionBucketSettings.push(qb);
                      });
                    });

                    var survSections = this.surveyForm.value.sections;
                    var questionOrder: number = 1;
                    var counter: number = 0;

                    var orderedBucketSettings = questionBucketSettings
                      .filter(x => x.entityTypeName.toLowerCase() === 'question text')
                      .sort((a, b) => b.entityId - a.entityId);
                    var finalQuestion = orderedBucketSettings[0];

                    survSections.forEach((s: any, i: any) => {
                      var shownQuestionsCount: number = 0;
                      s.questions.forEach((q: any, i: any) => {
                        if (!this.lastTab) {
                          var questionBucketSettingFound = questionBucketSettings
                            .filter(x => x.entityTypeName.toLowerCase() === 'question text' && x.entityId === q.qid);
                          if (questionBucketSettingFound.length > 0) {
                            q.isShow = true;
                            counter++;
                            if (survData.showQuestionNumber) {
                              q.order = questionOrder;
                              q.displayNumberText = questionOrder;
                              questionOrder++;
                              shownQuestionsCount++;
                            }

                          }
                          else {
                            q.isShow = false;
                          }

                        }

                      });

                      if (shownQuestionsCount === 0) {
                        s.isShowSection = false;
                      }


                    })

                    if (counter > 0) {
                      this.totalQuestionCount = counter;
                    }
                  }

                }


              });

            //Section for Survey User Section Settings / Last saved section
            this.http.get<surveyUserSectionSetting[]>(this.myAppUrl + this._getSurveyUserSectionSettingsUrl, {
              params: {
                'surveyId': this.surveyId,
                'serviceLineId': this.serviceLineId,
                'companyId': this.companyId,
                'userId': this.userId
              }
            }).toPromise().then(result => {
              this.surveyUserSectionSettingsList = result;

              if (this.surveyUserSectionSettingsList.length > 0) {
                var survSections = this.surveyData.metaBody.sections;
                survSections.forEach((s: any, i: any) => {
                  var matchingSurveySectionSetting = this.surveyUserSectionSettingsList
                    .filter(x => x.sectionId === s.id);
                  if (matchingSurveySectionSetting.length > 0) {
                    var index = survSections.indexOf(s);
                    this.tabIndex = index;
                    this.activeTabId = s.id;
                    var lastItem = survSections[survSections.length - 1];
                    if (s.id == lastItem.id) {
                      this.lastTab = true;
                    }
                    else {
                      this.lastTab = false;
                    }
                    if (s.type === 'Questionnaire') {
                      this.isQuestionnaireTabActive = true;
                    }
                  }
                });
              }

            });

          });

      });


  }
  upload(form: FormGroup, type: string) {
    let docname = form.controls["documentname"].value;
    let selectFile = form.controls["file"].value;

    let fileBaseName = selectFile.replace(/^.*[\\\/]/, '').split('.').slice(0, -1).join('.');

    let specialCharsRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
    if (specialCharsRegex.test(fileBaseName)) {
      //this.toasterService.error('Please ensure that the name of attached document does not contain special characters (&, #, %, @, etc.).', 'Error', { timeOut: 10000 });
      return;
    }

    if (form.controls["documentname"].value == "" || this.selectedFiles == null) {
      //this.toasterService.error('Please enter all mandatory fields.');
    }
    else {
      this.formdata = new FormData();
      this.formdata.append('file', this.selectedFiles.item(0) ?? '0');
      let mbValue: number = Number(this.selectedFiles.item(0)?.size) / 1e+6;
      // let type: string = this.getDocumentTab();
      let sectionId: number = 0;
      if (type == "SectionTab") {
        sectionId = this.selectedSection.Id;
      }
      else {
        this.selectedSection.Id = 0;
        this.selectedSection.Name = '';
      }
      if (mbValue < 20) {

        if (this.ssUserId === '-1') {
          var surveyIdString = 'surveyId_' + this.surveyId;
          var localStorageString = localStorage.getItem(surveyIdString);

          if (localStorageString !== '' && localStorageString !== null) {
            this.ssUserId = localStorageString;
          }
        }

        this.http.post(this.myAppUrl + this._uploadUrl, this.formdata, {
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          },
          params: {
            serviceLineId: this.serviceLineId,
            companyId: this.companyId,
            //  userId: this.EncrDecr.get(localStorage.getItem('userId')),
            userId: this.ssUserId,
            documentName: form.controls["documentname"].value,
            surveyId: this.surveyId,
            sectionId: sectionId.toString(),
            fileName: this.selectedFiles[0].name
          }
        }).subscribe(result => {
          if (type == 'DocumentsTab') {
            this.surveyData.metaBody.uploadedDocumentsList.push(<SurveyEntity.uploadedDocuments>(result));
            //this.gridapi.setRowData(this.surveyData.metaBody.uploadedDocumentsList);

            this.DocSuccessOrFailureMessage = "File has been successfully uploaded";
            window.setTimeout(() => {
              this.DocSuccessOrFailureMessage = '';
            }, 1200);
            this.docForm.patchValue({
              documentName: null
            });
          }
          else if (type == "SectionTab") {
            this.sectionDocuments.push(<SurveyEntity.uploadedDocuments>(result));
            this.sectiongridapi.setRowData(this.sectionDocuments);
            //this.toasterService.success("File has been successfully uploaded", this.selectedSection.Name);
            this.sectionDocs.patchValue({
              documentName: null
            });
          }
          form.controls['documentname'].reset();
          form.controls['file'].reset();
        });
      }
      else {
        //this.toasterService.error('file size can not be greaterthan 20MB', 'File Upload');
      }
    }
  }
  DocumentDownLoad(params: any) {
    const element = this.renderer.createElement('a');
    const elementI = this.renderer.createElement('i');
    elementI.setAttribute('class', 'fa  fa-download anchor-cursor');
    this.renderer.appendChild(element, elementI);
    this.renderer.listen(element, 'click', () => {
      let parameter = "?documentId=" + params.data.documentId + "&fileType=" + params.data.fileType;
      window.open(this.myAppUrl + this._downLoadUrl + parameter);
    });
    return element;

  }
  selectFile(event: any, form: FormGroup) {

    if (event.target.files == null) {
      this.isFileInvalid = true;
    }
    else {
      this.isFileInvalid = false;
      this.selectedFiles = event.target.files;
      this.tempdDcumentname = form.controls["documentname"].value;

    }

  }
  getDocumentTab(): string {
    let type: string;
    if ($('[formarrayname="sections"]').find('a.active:visible').length == 0) {
      type = "DocumentsTab";
    }
    else {
      type = "SectionTab";
    }
    return type;
  }

  RemoveDocument() {
    this.formdata = new FormData();
    this.formdata.append('documentId', this.currentDeletingdocumentId.toString());
    let type: string = this.getDocumentTab();
    this.http.post(this.myAppUrl + this._removeUrl, this.formdata, {
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      },
      params: {
        'surveyId': this.surveyId,
        'serviceLineId': this.serviceLineId,
        'companyId': this.companyId,
        'isPreview': this.isPreview
      }
    }).subscribe(result => {
      if (result == "true") {
        let index: number = 0;
        if (type == 'DocumentsTab') {
          index = this.surveyData.metaBody.uploadedDocumentsList.findIndex(d => d.documentId == this.currentDeletingdocumentId);
          this.surveyData.metaBody.uploadedDocumentsList.splice(index, 1);

          //this.gridapi.setRowData(this.surveyData.metaBody.uploadedDocumentsList);
          this.DocSuccessOrFailureMessage = "File has been deleted successfully.";
          window.setTimeout(() => {
            this.DocSuccessOrFailureMessage = '';
          }, 1200);
        }
        else if (type == 'SectionTab') {
          index = this.sectionDocuments.findIndex(d => d.documentId == this.currentDeletingdocumentId);
          this.sectionDocuments.splice(index, 1);
          this.sectiongridapi.setRowData(this.sectionDocuments);
          //this.toasterService.success("File has been deleted successfully.", this.selectedSection.Name);
        }
      }

    });

  }
  setProgressBarAttemptedQuesCount(qs: SurveyEntity.Question) {
    if (qs.type == "Matrix") {
      let isMatrixQsAttempted = false;
      if (!isMatrixQsAttempted) {
        qs.matrix.rowdataFields.forEach((r: any, ri: any) => {
          if (!isMatrixQsAttempted) {
            r.cellReferences.forEach((cell: any, cr: any) => {
              if (!isMatrixQsAttempted) {
                if (cell.value != '')
                  isMatrixQsAttempted = true;
              }
            });
          }
        });
      }
      if (isMatrixQsAttempted) {
        this.attemptedQuestionCount = this.attemptedQuestionCount + 1;
      }
      isMatrixQsAttempted = false;
    }
    if (qs.type == "MultipleChoice" || qs.type == "MultipleResponse" || qs.type == "Slider" || qs.type == "RankingSort"
      || qs.type == "Description" || qs.type == "TextInput" || qs.type == "Picklist" || qs.type == "DateTime") {
      if (qs.value != '') {
        this.attemptedQuestionCount = this.attemptedQuestionCount + 1;
      }
    }
  }
}

export interface OptionList {
  questionId: number;
  tmpOptions: Options;
  sectionId: number;
}

export interface QuestionLanguageSetting {
  mappingId: number;
  questionId: number;
  entityTypeId: number;
  entityId: number;
  languageId: number;
  languageText: string;
  entityTypeText: string;
}

export interface SurveyProviderLanguageMappedDetails {
  mappingId: number;
  surveyId: number;
  surveyName: string;
  serviceLineId: number;
  serviceLineName: string;
  companyId: number;
  companyName: string;
  languageId: number;
  languageName: string;
  languageCode: string;
}

export interface SingleSurveyLinkUserDetails {
  userId: number;
  userFirstName: string;
  userLastName: string;
  userEmailAddress: string;
}

export interface surveyProviderBucketSetting {
  mappingId: number;
  surveyId: number;
  serviceLineId: number;
  companyId: number;
  bucketId: number;
  entityTypeId: number;
  entityId: number;
  entityTypeName: string;
  entityValue: string;
}

export interface surveyUserSectionSetting {
  mappingId: number;
  surveyId: number;
  serviceLineId: number;
  companyId: number;
  userId: number;
  sectionId: number;
  surveyName: string;
  sectionName: string;
}

interface mappedSurveyProgressbarConfigDetail {
  mappingId: number,
  surveyId: number,
  surveyName: string,
  configurationId: number,
  propertyType: string,
  propertyValue: string
}
interface sectionConfigDetail {
  id: number,
  surveyId: number,
  sectionId: number,
  sectionBGColor: string,
  sectionType: string,
}

interface UISetting {
  id: number,
  uIconfigurationName: string,
  configurationIdentifierID: number,
  uiControlName: string,
  styles: UICommonAtributes,
  workSpaceID: number
}

interface UICommonAtributes {
  color: string,
  margin: string
}

interface MatrixQuestionConditionalSetting {
  surveyId: number;
  sectionId: number;
  questionId: number;
  questionRowItemId: number;
  questionColumnItemId: number;
  actionBySectionId: number;
  actionByQuestionId: number;
  isShow: boolean
}

